(function() {
  // Suppress errors from external recording scripts that try to serialize DOM operations
  // These errors don't break functionality but clutter the console
  const originalErrorHandler = window.onerror;
  window.addEventListener('error', function(event) {
    // Suppress errors from record.js trying to construct invalid selectors with newline characters
    if (event.message && event.message.includes('Failed to execute \'querySelectorAll\'') && 
        event.message.includes('Optic Cut-3')) {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
  }, true);
  
  // Variables that need to be accessible throughout
  let sectionId = null;
  let currentProductId = null;
  let initialized = false;
  
  // Function to check for and parse config
  function getConfig() {
    const configElement = document.getElementById('cloak-color-config');
    if (!configElement) {
      return null;
    }
    
    try {
      const config = JSON.parse(configElement.textContent);
      if (!config.sectionId || !config.productId) {
        console.error('[Cloak Color] Missing required config values:', config);
        return null;
      }
      return config;
    } catch (e) {
      console.error('[Cloak Color] Error parsing config:', e);
      return null;
    }
  }
  
  // Function to initialize the color selector
  function initializeColorShellSelector() {
    if (initialized) {
      return true; // Already initialized
    }
    
    const config = getConfig();
    if (!config) {
      return false;
    }
    
    sectionId = config.sectionId;
    currentProductId = config.productId;
    
    initialized = true;
    return true;
  }
  
  function getColorPriceAdjustment(handle) {
    if (handle === 'cloak-black') return 0;
    if (handle === 'cloak-recon-haze-topo') return 1199;
    if (handle === 'cloak-mc-alpine') return 1199;
    if (handle === 'cloak-mc-arid') return 1199;
    if (handle === 'cloak-mc-tropic') return 1199;
    if (handle === 'cloak-mc-black') return 1199;
    return 799;
  }
  const BASE_COLOR_INDEX = 0; // First color (black) is the base, no price adjustment

  // localStorage helpers for tracking color shell metadata
  const METADATA_STORAGE_KEY = 'cloak-color-shell-metadata';

  function getColorShellMetadata() {
    try {
      const stored = localStorage.getItem(METADATA_STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      console.error('[Cloak Color] Error reading metadata from localStorage:', e);
      return {};
    }
  }

  function setColorShellMetadata(cartItemKey, mainProductKey, instanceId, timestamp) {
    try {
      const metadata = getColorShellMetadata();
      metadata[cartItemKey] = {
        mainProductKey: mainProductKey || '',
        instanceId: instanceId,
        timestamp: timestamp
      };
      localStorage.setItem(METADATA_STORAGE_KEY, JSON.stringify(metadata));
      console.log('[Cloak Color] Stored metadata for', cartItemKey, ':', metadata[cartItemKey]);
    } catch (e) {
      console.error('[Cloak Color] Error storing metadata in localStorage:', e);
    }
  }

  function getColorShellMainProductKey(cartItemKey) {
    const metadata = getColorShellMetadata();
    return metadata[cartItemKey]?.mainProductKey || null;
  }
  window.getColorShellMainProductKey = getColorShellMainProductKey;

  function removeColorShellMetadata(cartItemKey) {
    try {
      const metadata = getColorShellMetadata();
      delete metadata[cartItemKey];
      localStorage.setItem(METADATA_STORAGE_KEY, JSON.stringify(metadata));
      console.log('[Cloak Color] Removed metadata for', cartItemKey);
    } catch (e) {
      console.error('[Cloak Color] Error removing metadata from localStorage:', e);
    }
  }

  function cleanupAllColorShellMetadata() {
    try {
      localStorage.removeItem(METADATA_STORAGE_KEY);
      console.log('[Cloak Color] Cleared all color shell metadata from localStorage');
    } catch (e) {
      console.error('[Cloak Color] Error clearing metadata from localStorage:', e);
    }
  }
  
  // Get product IDs from the JSON script tag
  const productIdsElement = document.getElementById('cloak-color-product-ids');
  const colorProductIds = productIdsElement ? JSON.parse(productIdsElement.textContent) : [
    'cloak-black',
    'cloak-recon-haze-topo',
    'cloak-arctic-white',
    'cloak-safety-yellow',
    'cloak-neon-pink',
    'cloak-safety-orange',
    'cloak-purple',
    'cloak-police-blue',
    'cloak-army-green',
    'cloak-black-carbon-fiber',
    'cloak-dark-grey',
    'cloak-mc-alpine',
    'cloak-mc-arid',
    'cloak-mc-tropic',
    'cloak-mc-black'
  ];
  
  const grid = document.getElementById('cloak-colors-grid');
  
  // Function to get price container (lazy evaluation to handle late sectionId)
  function getPriceContainer() {
    if (sectionId) {
      return document.querySelector(`#price-${sectionId}`) || document.querySelector('.price');
    }
    return document.querySelector('.price');
  }
  
  let basePrice = null;
  let colorProducts = [];
  let originalProductImages = []; // Store original product images
  
  function getBasePrice() {
    if (window.cloakBetaBasePrice) return window.cloakBetaBasePrice;
    if (basePrice !== null) return basePrice;
    
    const priceContainer = getPriceContainer();
    const priceElement = priceContainer?.querySelector('.price-item--regular, .price-item--sale, .price-item--last');
    if (priceElement) {
      const priceText = priceElement.textContent.trim();
      // Match numbers with optional decimals and commas (e.g., "29.99" or "1,299.99")
      const match = priceText.match(/[\d,]+\.?\d*/);
      if (match) {
        // Use parseFloat to preserve decimals, then convert to cents
        basePrice = Math.round(parseFloat(match[0].replace(/,/g, '')) * 100);
        return basePrice;
      }
    }
    
    if (window.product && window.product.selected_or_first_available_variant) {
      basePrice = window.product.selected_or_first_available_variant.price;
      return basePrice;
    }
    
    return null;
  }
  
  function formatPrice(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
  
  function storeOriginalImages() {
    // Store the black image as the original/second image
    const blackImageUrl = 'https://cdn.shopify.com/s/files/1/0881/4854/1726/files/4696e3b8-1420-44c9-b0f4-39215a3c779f.jpg?v=1763056859';
    
    // Try multiple selectors to find the second product image (exclude badges)
    const selectors = [
      `#Slider-Gallery-${sectionId} .product__media-item img:not([src*="badge"]):not(.ready-to-ship-badge img):not(.quick-ship-badge img):not(.new-badge img):not(.sale-badge img):not(.coming-soon-badge img)`,
      '.product__media-item img:not([src*="badge"]):not(.ready-to-ship-badge img):not(.quick-ship-badge img):not(.new-badge img):not(.sale-badge img):not(.coming-soon-badge img)',
      '.product-media-container img.global-media-settings:not([src*="badge"])',
      '.product-media-container img[data-media-id]:not([src*="badge"])',
      '.product__media-wrapper img:not([src*="badge"])',
      '.product__media img:not([src*="badge"])'
    ];
    
    let allImages = [];
    for (const selector of selectors) {
      const images = document.querySelectorAll(selector);
      for (const img of images) {
        // Double check it's not a badge or in color selector
        if (img && img.src && 
            !img.closest('.cloak-colors-section') && 
            !img.closest('.ready-to-ship-badge') &&
            !img.closest('.quick-ship-badge') &&
            !img.closest('.new-badge') &&
            !img.closest('.sale-badge') &&
            !img.closest('.coming-soon-badge') &&
            !img.src.includes('badge') &&
            (img.src.includes('products') || img.src.includes('files'))) {
          if (!allImages.includes(img)) {
            allImages.push(img);
          }
        }
      }
    }
    
    // Get the second image (index 1) if available, otherwise use first
    const mainImage = allImages.length > 1 ? allImages[1] : (allImages.length > 0 ? allImages[0] : null);
    
    // Store the black image as the original, and also update the second image to show black
    if (mainImage) {
      // Update the second image to show the black image immediately
      if (mainImage.tagName === 'IMG') {
        mainImage.src = blackImageUrl;
        // Also update srcset if present
        if (mainImage.hasAttribute('srcset')) {
          mainImage.srcset = blackImageUrl;
        }
      }
      originalProductImages = [blackImageUrl];
    } else {
      // If no image found, still store the black image URL
      originalProductImages = [blackImageUrl];
    }
  }
  
  function restoreOriginalImages() {
    if (originalProductImages.length === 0) {
      return;
    }
    
    // Find the second product image using the same selectors as storeOriginalImages (exclude badges)
    const selectors = [
      `#Slider-Gallery-${sectionId} .product__media-item img:not([src*="badge"]):not(.ready-to-ship-badge img):not(.quick-ship-badge img):not(.new-badge img):not(.sale-badge img):not(.coming-soon-badge img)`,
      '.product__media-item img:not([src*="badge"]):not(.ready-to-ship-badge img):not(.quick-ship-badge img):not(.new-badge img):not(.sale-badge img):not(.coming-soon-badge img)',
      '.product-media-container img.global-media-settings:not([src*="badge"])',
      '.product-media-container img[data-media-id]:not([src*="badge"])',
      '.product__media-wrapper img:not([src*="badge"])',
      '.product__media img:not([src*="badge"])'
    ];
    
    let allImages = [];
    for (const selector of selectors) {
      const images = document.querySelectorAll(selector);
      for (const img of images) {
        // Double check it's not a badge or in color selector
        if (img && 
            !img.closest('.cloak-colors-section') && 
            !img.closest('.ready-to-ship-badge') &&
            !img.closest('.quick-ship-badge') &&
            !img.closest('.new-badge') &&
            !img.closest('.sale-badge') &&
            !img.closest('.coming-soon-badge') &&
            !img.src.includes('badge') &&
            (img.src.includes('products') || img.src.includes('files'))) {
          if (!allImages.includes(img)) {
            allImages.push(img);
          }
        }
      }
    }
    
    // Get the second image (index 1) if available, otherwise use first
    const mainImage = allImages.length > 1 ? allImages[1] : (allImages.length > 0 ? allImages[0] : null);
    
    if (mainImage && originalProductImages[0]) {
      const originalUrl = originalProductImages[0];
      mainImage.src = originalUrl;
      if (mainImage.hasAttribute('srcset')) {
        mainImage.removeAttribute('srcset');
      }
      // Also update any picture source elements
      const picture = mainImage.closest('picture');
      if (picture) {
        const sources = picture.querySelectorAll('source');
        sources.forEach(source => {
          if (source.srcset) {
            source.srcset = originalUrl;
          }
        });
      }
      }
  }
  
  function updateProductImages(product) {
    if (!product) {
      return;
    }
    
    // Prioritize featured_image, then first image from images array
    let mainImageUrl = null;
    
    if (product.featured_image) {
      // Use featured_image - this is the main product image
      if (typeof product.featured_image === 'string') {
        mainImageUrl = product.featured_image;
      } else if (product.featured_image.src) {
        mainImageUrl = product.featured_image.src;
      } else {
        mainImageUrl = product.featured_image;
      }
    } else if (product.images && product.images.length > 0) {
      // Fallback to first image from images array
      const firstImage = product.images[0];
      if (typeof firstImage === 'string') {
        mainImageUrl = firstImage;
      } else if (firstImage.src) {
        mainImageUrl = firstImage.src;
      } else {
        mainImageUrl = firstImage;
      }
    }
    
    if (!mainImageUrl) {
      return;
    }
    
    // Helper function to convert image URL to high-quality size (1200px or master)
    function getHighQualityImageUrl(url) {
      if (!url) return url;
      if (url.includes('cdn.shopify.com')) {
        // Remove existing size parameters
        url = url.replace(/\?v=\d+/, '').replace(/_(small|medium|large|grande|master|1024x1024|2048x2048|533x|200x)\./, '.');
        
        // Extract file extension
        const extMatch = url.match(/\.(jpg|jpeg|png|gif|webp)/i);
        if (extMatch) {
          // Use 1200px width for high quality, or master if available
          // Try to get the base URL without size suffix
          const baseUrl = url.replace(extMatch[0], '');
          // Construct high-quality URL
          url = baseUrl + '_1200x' + extMatch[0];
        }
      }
      return url;
    }
    
    // Helper function to update an image element
    function updateImageElement(img, imageUrl) {
      if (!img || !imageUrl) return;
      
      // EXCLUDE color selector images - don't update images inside cloak-colors-section
      if (img.closest('.cloak-colors-section') || img.closest('.cloak-color-item')) {
        return;
      }
      
      const highQualityUrl = getHighQualityImageUrl(imageUrl);
      if (!highQualityUrl) return;
      
      // Update the image source
      img.src = highQualityUrl;
      
      // Update srcset to use the high-quality image
      if (img.hasAttribute('srcset')) {
        // Create a responsive srcset with multiple sizes
        const baseUrl = highQualityUrl.replace(/_1200x\./, '.');
        const extMatch = baseUrl.match(/\.(jpg|jpeg|png|gif|webp)/i);
        if (extMatch) {
          const sizes = [533, 720, 940, 1066, 1200];
          const srcset = sizes.map(size => {
            const sizeUrl = baseUrl.replace(extMatch[0], `_${size}x${extMatch[0]}`);
            return `${sizeUrl} ${size}w`;
          }).join(', ');
          img.srcset = srcset;
        } else {
          img.srcset = highQualityUrl;
        }
      }
      
      img.loading = 'eager';
      if (img.dataset) {
        img.dataset.productFeaturedImage = highQualityUrl;
      }
      
      // Force image reload
      img.style.opacity = '0';
      setTimeout(() => {
        img.style.opacity = '1';
      }, 100);
    }
    
    // Find product media gallery containers - EXCLUDE color selector section
    const productMediaSelectors = [
      'media-gallery',
      `#MediaGallery-${sectionId}`,
      '.product__media-list',
      '.product-media-container',
      '.product__media-wrapper',
      '.product__media',
      '[data-product-media-container]',
      '.product__media-item',
      '.product-media-item'
    ];
    
    let foundImages = [];
    
    // Try to find images within product media containers only
    productMediaSelectors.forEach(selector => {
      try {
        const containers = document.querySelectorAll(selector);
        containers.forEach(container => {
          // Make sure we're not in the color selector section
          if (container.closest('.cloak-colors-section')) return;
          
          const images = container.querySelectorAll('img');
          images.forEach(img => {
            // Double check it's not a color selector image
            if (!img.closest('.cloak-colors-section') && !img.closest('.cloak-color-item')) {
              if (!foundImages.includes(img)) {
                foundImages.push(img);
              }
            }
          });
        });
      } catch (e) {
        // Selector might be invalid, skip
      }
    });
    
    // Also try specific product gallery selectors
    const gallerySelectors = [
      'img.global-media-settings:not(.cloak-color-image)',
      '.product__media-item img:not(.cloak-color-image)',
      '.product-media-item img:not(.cloak-color-image)',
      '[data-media-id] img:not(.cloak-color-image)',
      '.product__media-list img:not(.cloak-color-image)',
      `#Slider-Gallery-${sectionId} img:not(.cloak-color-image)`
    ];
    
    gallerySelectors.forEach(selector => {
      try {
        const images = document.querySelectorAll(selector);
        images.forEach(img => {
          // Exclude color selector images
          if (!img.closest('.cloak-colors-section') && !img.closest('.cloak-color-item')) {
            if (!foundImages.includes(img)) {
              foundImages.push(img);
            }
          }
        });
      } catch (e) {
        // Selector might be invalid, skip
      }
    });
    
    if (foundImages.length > 0 && mainImageUrl) {
      // Prioritize finding the first/active image in the gallery (exclude badges)
      // Filter out badge images first
      const productImages = foundImages.filter(img => {
        return img && 
               !img.src.includes('badge') &&
               !img.closest('.ready-to-ship-badge') &&
               !img.closest('.quick-ship-badge') &&
               !img.closest('.new-badge') &&
               !img.closest('.sale-badge') &&
               !img.closest('.coming-soon-badge') &&
               (img.src.includes('products') || img.src.includes('files'));
      });
      
      // Try to find the second image in the gallery (not the first)
      let mainImage = null;
      
      // Method 1: Find the second media item in the gallery
      const galleryList = document.querySelector(`#Slider-Gallery-${sectionId}, .product__media-list, .product__media-wrapper, #MediaGallery-${sectionId}`);
      if (galleryList) {
        const mediaItems = galleryList.querySelectorAll('.product__media-item, .product-media-item, [data-media-id]');
        if (mediaItems.length > 1) {
          // Get the second media item (index 1)
          const secondMediaItem = mediaItems[1];
          if (secondMediaItem) {
            const imgInSecondItem = secondMediaItem.querySelector('img');
            if (imgInSecondItem && productImages.includes(imgInSecondItem)) {
              mainImage = imgInSecondItem;
            }
          }
        }
      }
      
      // Method 2: Try to find the active image (if second item is active)
      if (!mainImage) {
        const activeImages = productImages.filter(img => {
          const parent = img.closest('.product__media-item, .product-media-item');
          return parent && (parent.classList.contains('is-active') || parent.classList.contains('active'));
        });
        // If there's an active image and it's not the first one, use it
        if (activeImages.length > 0) {
          const galleryList = document.querySelector(`#Slider-Gallery-${sectionId}, .product__media-list, .product__media-wrapper, #MediaGallery-${sectionId}`);
          if (galleryList) {
            const mediaItems = galleryList.querySelectorAll('.product__media-item, .product-media-item, [data-media-id]');
            activeImages.forEach(activeImg => {
              const parent = activeImg.closest('.product__media-item, .product-media-item, [data-media-id]');
              if (parent && mediaItems.length > 1 && Array.from(mediaItems).indexOf(parent) > 0) {
                mainImage = activeImg;
              }
            });
          }
        }
      }
      
      // Method 3: Get the second product image (not badge, not first)
      if (!mainImage && productImages.length > 1) {
        mainImage = productImages[1];
      }
      
      if (mainImage) {
        updateImageElement(mainImage, mainImageUrl);
        
        // Also update any picture source elements if present
        const picture = mainImage.closest('picture');
        if (picture) {
          const sources = picture.querySelectorAll('source');
          sources.forEach(source => {
            const highQualityUrl = getHighQualityImageUrl(mainImageUrl);
            if (source.srcset && highQualityUrl) {
              source.srcset = highQualityUrl;
            }
          });
        }
        
        // Update any background images in the parent container
        const mediaContainer = mainImage.closest('.product__media-item, .product-media-item, .media');
        if (mediaContainer) {
          const highQualityUrl = getHighQualityImageUrl(mainImageUrl);
          if (highQualityUrl) {
            mediaContainer.style.backgroundImage = `url(${highQualityUrl})`;
          }
        }
      }
      
      // Do NOT update other gallery images - only the second image
    }
    
    // Trigger any theme image update events
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
      publish(PUB_SUB_EVENTS.mediaUpdate || 'media:update', { images: [mainImageUrl], product: product });
    }
    
    // Dispatch custom event for theme compatibility
    window.dispatchEvent(new CustomEvent('product:media:update', { 
      detail: { images: [mainImageUrl], product: product } 
    }));
  }
  
  function isBaseColor(product) {
    if (!product) return false;
    const handle = (product.handle || '').toLowerCase();
    // Only cloak-black or black-xl is the base (free), black carbon fiber is an upgrade
    return handle === 'cloak-black' || handle === 'black-xl';
  }
  
  function updatePriceForColor(colorIndex, product) {
    // Check for Bag Bundle page and skip price update
    if (document.querySelector('.holster-selection-section')) {
      return;
    }

    const priceContainer = getPriceContainer();
    if (!priceContainer) {
      return;
    }
    
    const base = getBasePrice();
    if (!base) {
      return;
    }
    
    // Black product (cloak-black) = base price, no adjustment
    // All other colors = base price + $7.99
    const isBlackProduct = product && (product.handle === 'cloak-black' || product.handle === 'black-xl' || isBaseColor(product));
    const magAdj = window.cloakMagCarrierPrice || 0;
    const priceAdj = getColorPriceAdjustment(product ? product.handle : colorProductIds[colorIndex]);
    const adjustedPrice = base + priceAdj + magAdj;
    
    const priceElements = priceContainer.querySelectorAll('.price-item--regular:not(s), .price-item--sale, .price-item--last');
    priceElements.forEach(el => {
      if (!el.closest('s')) {
        const originalText = el.textContent.trim();
        if (originalText.includes('$') || originalText.match(/\d/)) {
          const newPrice = formatPrice(adjustedPrice);
          // Always append USD to keep currency explicit
          el.textContent = newPrice + ' USD';
        }
      }
    });
  }
  
  // Helper function to check if an image URL is a badge
  function isBadgeImage(url) {
    if (!url) return true;
    const urlLower = url.toLowerCase();
    return urlLower.includes('badge') || 
           urlLower.includes('ready-to-ship') ||
           urlLower.includes('quick-ship') ||
           urlLower.includes('new-badge') ||
           urlLower.includes('sale-badge') ||
           urlLower.includes('coming-soon');
  }
  
  // Get the current product's featured image (for black/default option)
  function getCurrentProductImage() {
    // Priority 1: Try to get from window.product.featured_image (most reliable)
    if (window.product && window.product.featured_image) {
      let featuredImageUrl = null;
      if (typeof window.product.featured_image === 'string') {
        featuredImageUrl = window.product.featured_image;
      } else if (window.product.featured_image.src) {
        featuredImageUrl = window.product.featured_image.src;
      }
      
      // Only return if it's not a badge image
      if (featuredImageUrl && !isBadgeImage(featuredImageUrl)) {
        return featuredImageUrl;
      }
    }
    
    // Priority 2: Try to get from window.product.images array (first non-badge image)
    if (window.product && window.product.images && window.product.images.length > 0) {
      for (const img of window.product.images) {
        const imgUrl = typeof img === 'string' ? img : (img.src || img);
        if (imgUrl && !isBadgeImage(imgUrl)) {
          return imgUrl;
        }
      }
    }
    
    // Priority 3: Try to get from originalProductImages (stored on page load)
    if (originalProductImages && originalProductImages.length > 0) {
      for (const imgUrl of originalProductImages) {
        if (imgUrl && !isBadgeImage(imgUrl)) {
          return imgUrl;
        }
      }
    }
    
    // Priority 4: Fallback: try to get from the second product image on the page (exclude badges)
    const selectors = [
      `#Slider-Gallery-${sectionId} .product__media-item img:not([src*="badge"])`,
      '.product__media-item img:not([src*="badge"])',
      '.product-media-item img:not([src*="badge"])',
      '.product-media-container img.global-media-settings:not([src*="badge"])',
      '.product__media-wrapper img:not([src*="badge"])'
    ];
    
    let allImages = [];
    for (const selector of selectors) {
      const images = document.querySelectorAll(selector);
      for (const img of images) {
        // Double check it's not a badge
        if (img && img.src &&
            !img.closest('.ready-to-ship-badge') &&
            !img.closest('.quick-ship-badge') &&
            !img.closest('.new-badge') &&
            !img.closest('.sale-badge') &&
            !img.closest('.coming-soon-badge') &&
            !isBadgeImage(img.src) &&
            (img.src.includes('products') || img.src.includes('files'))) {
          if (!allImages.includes(img)) {
            allImages.push(img);
          }
        }
      }
    }
    
    // Return the second image (index 1) if available, otherwise first
    if (allImages.length > 1) {
      return allImages[1].src;
    } else if (allImages.length > 0) {
      return allImages[0].src;
    }
    
    return null;
  }
  
  function handleColorClick(colorIndex, product, isDefault) {
    // Update active state
    const colorItems = document.querySelectorAll('.cloak-color-item');
    colorItems.forEach((item, idx) => {
      if (idx === colorIndex) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    
    // Check if this is the black product
    const isBlackProduct = product && (product.handle === 'cloak-black' || product.handle === 'black-xl' || isBaseColor(product));
    
    if (product) {
      // Store the product for add to cart (including black)
      // Black will be added but with no price adjustment
      window.selectedColorProduct = product;
      updateProductImages(product);
      updatePriceForColor(colorIndex, product);
    }
    
    // When a color is selected in cloak-color-injection template, automatically set optic cut option
    // Black = "no", all other colors = "yes"
    if (!isDefault) {
      // Check if we're on the cloak-color-injection template
      const isCloakColorInjection = document.querySelector('[data-template-suffix="cloak-color-injection"]') || 
                                     document.body.classList.contains('template-product-cloak-color-injection') ||
                                     (window.location.pathname.includes('/products/') && document.querySelector('#cloak-color-config'));
      
      if (isCloakColorInjection) {
        // Determine target value: "no" for black, "yes" for all other colors
        const targetValue = isBlackProduct ? 'no' : 'yes';
        
        // Function to set optic cut (option3) to target value
        function setOpticCutValue() {
          try {
            // Find option3 container by looking for "Optic Cut" or third option
            const productFormInputs = document.querySelectorAll('.product-form__input');
            let option3Container = null;
            
            // Try to find by legend/label text containing "optic"
            for (const container of productFormInputs) {
              const legend = container.querySelector('legend')?.textContent?.toLowerCase() || '';
              const label = container.querySelector('.form__label')?.textContent?.toLowerCase() || '';
              if (legend.includes('optic') || label.includes('optic')) {
                option3Container = container;
                break;
              }
            }
            
            // If not found by text, use third option
            if (!option3Container && productFormInputs.length >= 3) {
              option3Container = productFormInputs[2];
            }
            
            if (!option3Container) return;
            
            // Find all radio buttons in option3 container
            const allRadios = option3Container.querySelectorAll('input[type="radio"]');
            if (allRadios.length === 0) return;
            
            // Find the target radio button
            let targetRadio = null;
            for (const radio of allRadios) {
              const radioValue = radio.value.toLowerCase().trim();
              // Check value
              if (radioValue === targetValue || radioValue.includes(targetValue)) {
                targetRadio = radio;
                break;
              }
              // Check label text - use getElementById instead of querySelector to avoid issues with special characters
              if (radio.id) {
                const label = document.getElementById(radio.id.replace(/^option/, 'label-')) || 
                             document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
                if (label) {
                  const labelText = label.textContent?.toLowerCase().trim() || '';
                  if (labelText === targetValue || labelText.includes(targetValue)) {
                    targetRadio = radio;
                    break;
                  }
                }
              }
            }
            
            if (targetRadio && !targetRadio.checked) {
              // Directly set checked state and trigger events to avoid recording script issues
              try {
                // Uncheck other radios in the same container (same group) first
                // Use the container we already found instead of accessing the name property
                // Use setAttribute/removeAttribute instead of property assignment to avoid recording script interception
                allRadios.forEach(r => {
                  if (r !== targetRadio) {
                    try {
                      r.removeAttribute('checked');
                      // Also set the property for compatibility
                      if (r.checked) r.checked = false;
                      r.dispatchEvent(new Event('change', { bubbles: true }));
                    } catch (e) {
                      // Ignore errors from recording scripts
                    }
                  }
                });
                
                // Set the target radio as checked using setAttribute to avoid recording script interception
                try {
                  targetRadio.setAttribute('checked', 'checked');
                  // Also set the property for compatibility
                  if (!targetRadio.checked) targetRadio.checked = true;
                  targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
                  targetRadio.dispatchEvent(new Event('input', { bubbles: true }));
                } catch (e) {
                  // Ignore errors from recording scripts
                }
                
                // Also try to click the label if it exists (wrapped in try-catch to handle recording script errors)
                const label = targetRadio.id ? 
                             (document.getElementById(targetRadio.id.replace(/^option/, 'label-')) || 
                              (() => {
                                try {
                                  return document.querySelector(`label[for="${CSS.escape(targetRadio.id)}"]`);
                                } catch (e) {
                                  return null;
                                }
                              })()) : 
                             null;
                if (label) {
                  try {
                    label.click();
                  } catch (e) {
                    // Ignore errors from recording scripts
                  }
                }
              } catch (e) {
                // Fallback: try direct click if setting checked fails
                try {
                  targetRadio.click();
                } catch (e2) {
                  // Ignore all errors - recording script issues shouldn't break functionality
                }
              }
            }
          } catch (error) {
            // Silently handle errors from external recording scripts or other issues
            // This prevents errors from breaking the color selection functionality
            console.error('[Cloak Color] Error in setOpticCutValue:', error);
          }
        }
        
        // Try immediately and also with delays to ensure DOM is ready and variant system has updated
        // Use longer delays to allow variant system to process the color change first
        try {
          setOpticCutValue();
          setTimeout(() => { try { setOpticCutValue(); } catch(e) {} }, 300);
          setTimeout(() => { try { setOpticCutValue(); } catch(e) {} }, 600);
          setTimeout(() => { try { setOpticCutValue(); } catch(e) {} }, 1000);
          setTimeout(() => { try { setOpticCutValue(); } catch(e) {} }, 1500);
          setTimeout(() => { try { setOpticCutValue(); } catch(e) {} }, 2000);
        } catch (error) {
          console.error('[Cloak Color] Error scheduling setOpticCutValue:', error);
        }
      }
    }
    
    // On mobile, move slider to second image to show the updated color
    if (window.innerWidth <= 749) {
      moveSliderToSecondImage();
    }
  }
  
  function moveSliderToSecondImage() {
    // Find the slider and second media item
    const galleryList = document.querySelector(`#Slider-Gallery-${sectionId}, .product__media-list`);
    if (!galleryList) return;
    
    const mediaItems = galleryList.querySelectorAll('.product__media-item');
    if (mediaItems.length < 2) return;
    
    const secondMediaItem = mediaItems[1];
    if (!secondMediaItem) return;
    
    // Get the media ID from the second item
    const mediaId = secondMediaItem.getAttribute('data-media-id');
    if (!mediaId) return;
    
    // Try to use media-gallery component's setActiveMedia method
    const mediaGallery = document.querySelector(`#MediaGallery-${sectionId}`);
    if (mediaGallery && mediaGallery.setActiveMedia) {
      mediaGallery.setActiveMedia(mediaId, false);
      return;
    }
    
    // Fallback: manually scroll to second image
    setTimeout(() => {
      // Remove active class from all items
      mediaItems.forEach(item => item.classList.remove('is-active'));
      
      // Add active class to second item
      secondMediaItem.classList.add('is-active');
      
      // Scroll the slider to show the second image
      if (galleryList.scrollTo) {
        galleryList.scrollTo({
          left: secondMediaItem.offsetLeft,
          behavior: 'smooth'
        });
      } else {
        galleryList.scrollLeft = secondMediaItem.offsetLeft;
      }
      
      // Also try to trigger slider component update
      const sliderComponent = galleryList.closest('slider-component');
      if (sliderComponent && sliderComponent.slider) {
        sliderComponent.slider.scrollTo({ left: secondMediaItem.offsetLeft });
      }
    }, 100);
  }
  
  async function loadColorProducts() {
    if (!grid) return;
    
      // Check if products were already loaded via Liquid
      const productsDataElement = document.getElementById('cloak-color-products-data');
      let liquidProducts = [];
      if (productsDataElement) {
        try {
          const products = JSON.parse(productsDataElement.textContent);
          if (products && products.length > 0) {
            liquidProducts = products;
            
            // Sort: black first, then alphabetically by title
            liquidProducts.sort((a, b) => {
              const aHandle = (a.handle || '').toLowerCase();
              const bHandle = (b.handle || '').toLowerCase();
              const aIsBlack = aHandle === 'cloak-black' || aHandle === 'black-xl';
              const bIsBlack = bHandle === 'cloak-black' || bHandle === 'black-xl';
              
              // Black always comes first
              if (aIsBlack && !bIsBlack) return -1;
              if (!aIsBlack && bIsBlack) return 1;
              
              // For non-black products, sort alphabetically by title
              if (!aIsBlack && !bIsBlack) {
                const aTitle = (a.title || '').toUpperCase();
                const bTitle = (b.title || '').toUpperCase();
                if (aTitle < bTitle) return -1;
                if (aTitle > bTitle) return 1;
              }
              
              return 0;
            });
            
            colorProducts = liquidProducts;
            
            // Store products globally for use in interceptAddToCart
            window.cloakColorProducts = colorProducts;
            
            // Re-render products in sorted order (clear existing and re-render)
            grid.innerHTML = '';
            renderColorProducts(liquidProducts);
            
            // Initialize immediately - don't wait for images
            initColorPriceUpdates();
            // Store images asynchronously (non-blocking)
            setTimeout(() => storeOriginalImages(), 0);
            
            // Ensure default color (black) is selected if none is selected
            setTimeout(() => {
              if (!window.selectedColorProduct && colorProducts.length > 0) {
                const neededHandle = getBlackProductHandleForCartItem();
                const blackProduct = colorProducts.find(p => {
                  const handle = (p.handle || '').toLowerCase();
                  return handle === neededHandle;
                });
                if (blackProduct) {
                  window.selectedColorProduct = blackProduct;
                  console.log('[Cloak Color] loadColorProducts: Set default color to black');
                }
              }
            }, 100);
            
            return; // Products already loaded, exit early
          }
        } catch (e) {
          // Error parsing product data
        }
      }
    
    // Check if we have all expected products
    const expectedCount = colorProductIds.length;
    const loadedCount = liquidProducts.length;
    
    // If Liquid loaded some but not all, supplement with JavaScript
    if (loadedCount > 0 && loadedCount < expectedCount) {
      // Get handles and IDs of products already loaded (normalize for comparison)
      const loadedIdentifiers = new Set();
      liquidProducts.forEach(p => {
        if (p.handle) loadedIdentifiers.add(p.handle.toLowerCase());
        if (p.id) loadedIdentifiers.add(p.id.toString());
      });
      
      // Find missing products
      const missingProductIds = colorProductIds.filter(id => {
        // Check if this product is already loaded
        const normalizedId = id.toLowerCase();
        const isLoaded = loadedIdentifiers.has(normalizedId) || 
                        liquidProducts.some(p => 
                          (p.handle && p.handle.toLowerCase() === normalizedId) ||
                          (p.id && p.id.toString() === id)
                        );
        return !isLoaded;
      });
      
      // Load missing products via JavaScript
      if (missingProductIds.length > 0) {
        try {
          const missingProducts = await Promise.all(
            missingProductIds.map(async (productIdentifier) => {
              const isHandle = /[a-zA-Z-]/.test(productIdentifier);
              
              try {
                const response = await fetch(`/products/${productIdentifier}.js`);
                if (response.ok) {
                  const product = await response.json();
                  if (product && product.id) {
                    return product;
                  }
                }
              } catch (e) {
                // Error fetching product
              }
              
              return null;
            })
          );
          
          // Filter out nulls and add to colorProducts
          const validMissing = missingProducts.filter(p => p && p.id);
          if (validMissing.length > 0) {
            colorProducts = [...liquidProducts, ...validMissing];
            // Store products globally for use in interceptAddToCart
            window.cloakColorProducts = colorProducts;
            // Render the missing products
            renderColorProducts(validMissing, true); // true = append mode
          }
        } catch (error) {
          // Error loading missing products
        }
      }
      
      return; // We've supplemented the Liquid products
    }
    
    // Fallback: Try to load via JavaScript if Liquid didn't work
    const loadingElement = grid.querySelector('[data-loading="true"]');
    if (!loadingElement) return; // Products already loaded via Liquid
    
    try {
      const products = await Promise.all(
        colorProductIds.map(async (productIdentifier, index) => {
          const isHandle = /[a-zA-Z-]/.test(productIdentifier);

          try {
              const response = await fetch(`/products/${productIdentifier}.js`);
              if (response.ok) {
                const product = await response.json();
                if (product && product.id) {
                  return product;
                }
              } else {
                console.warn(`[Cloak Color] Product not found: ${productIdentifier} (${response.status})`);
              }
            } catch (e) {
              console.warn(`[Cloak Color] Error fetching product ${productIdentifier}:`, e.message);
            }

            if (!isHandle && window.Shopify && window.Shopify.products) {
              const productIdNum = parseInt(productIdentifier);
              const product = window.Shopify.products.find(p =>
                p.id === productIdNum ||
                p.id.toString() === productIdentifier.toString()
              );
              if (product) {
                return product;
              }
            }

            if (!isHandle) {
              const possibleHandles = [`cloak-${productIdentifier}`];
              for (const handle of possibleHandles) {
                try {
                  const response = await fetch(`/products/${handle}.js`);
                  if (response.ok) {
                    const product = await response.json();
                    if (product && product.id) {
                      return product;
                    }
                  }
                } catch (e) {
                  console.warn(`[Cloak Color] Error fetching alternative handle ${handle}:`, e.message);
                }
              }
            }

            console.warn(`[Cloak Color] Failed to load product: ${productIdentifier}`);
            return null;
        })
      );
      
      // Filter products - include all products with an ID (we'll mark out-of-stock separately)
      const validProducts = products.filter(p => {
        if (!p || !p.id) return false;
        // Include all products, we'll check inventory and mark as out-of-stock in rendering
        return true;
      });
      
        colorProducts = validProducts;

        // Store products globally for use in interceptAddToCart
        window.cloakColorProducts = colorProducts;

        if (validProducts.length === 0) {
          // Fallback: Try to load cloak-black or black-xl as the minimum color option
          try {
            const neededHandle = getBlackProductHandleForCartItem();
            const response = await fetch(`/products/${neededHandle}.js`);
            if (response.ok) {
              const blackProduct = await response.json();
              if (blackProduct && blackProduct.id) {
                colorProducts = [blackProduct];
                window.cloakColorProducts = colorProducts;

                if (loadingElement) {
                  loadingElement.remove();
                }

                renderColorProducts([blackProduct]);
                storeOriginalImages();
                initColorPriceUpdates();

                // Set black as the default selected color
                window.selectedColorProduct = blackProduct;
                console.log('[Cloak Color] loadColorProducts: Fallback - loaded cloak-black as only available color option');

                return;
              }
            }
          } catch (e) {
            console.warn('[Cloak Color] Fallback to load cloak-black failed:', e.message);
          }

          // If fallback failed, show error
          if (loadingElement) {
            loadingElement.innerHTML = 'Unable to load color products.<br>Please ensure all products are <strong>published</strong> and have correct handles.';
          }
          return;
        }
      
      // Sort: black first, then alphabetically by title
      validProducts.sort((a, b) => {
        const aHandle = (a.handle || '').toLowerCase();
        const bHandle = (b.handle || '').toLowerCase();
        const aIsBlack = aHandle === 'cloak-black' || aHandle === 'black-xl';
        const bIsBlack = bHandle === 'cloak-black' || bHandle === 'black-xl';
        
        // Black always comes first
        if (aIsBlack && !bIsBlack) return -1;
        if (!aIsBlack && bIsBlack) return 1;
        
        // For non-black products, sort alphabetically by title
        if (!aIsBlack && !bIsBlack) {
          const aTitle = (a.title || '').toUpperCase();
          const bTitle = (b.title || '').toUpperCase();
          if (aTitle < bTitle) return -1;
          if (aTitle > bTitle) return 1;
        }
        
        return 0;
      });
      
      loadingElement.remove();
      renderColorProducts(validProducts);
        storeOriginalImages();
        initColorPriceUpdates();
        
        // Ensure default color (black) is selected if none is selected
        setTimeout(() => {
          if (!window.selectedColorProduct && colorProducts.length > 0) {
            const neededHandle = getBlackProductHandleForCartItem();
            const blackProduct = colorProducts.find(p => {
              const handle = (p.handle || '').toLowerCase();
              return handle === neededHandle;
            });
            if (blackProduct) {
              window.selectedColorProduct = blackProduct;
              console.log('[Cloak Color] loadColorProducts: Set default color to black');
            }
          }
        }, 100);
      } catch (error) {
        if (loadingElement) {
          loadingElement.textContent = 'Error loading colors.';
        }
      }
  }
  
  function renderColorProducts(products, appendMode = false) {
    // If append mode, just add the products
    if (appendMode) {
      const html = products.map((product, index) => {
        // Calculate color index based on existing items
        const existingItems = grid.querySelectorAll('.cloak-color-item');
        const colorIndex = existingItems.length + index;
        
        return renderColorProductItem(product, colorIndex);
      }).join('');
      
      grid.insertAdjacentHTML('beforeend', html);
      
      // Re-initialize event listeners for new items
      initColorPriceUpdates();
      return;
    }
    
    // Render all products (black is now a product, so it's included in the products array)
    let html = products.map((product, index) => {
      const colorIndex = index; // Start from 0
      return renderColorProductItem(product, colorIndex);
    }).join('');
    
    grid.innerHTML = html;
  }
  
  // Helper function to check if product is out of stock
  function isProductOutOfStock(product) {
    if (!product) return false;
    
    // Black is non-inventoried, so always available
    const isBlackProduct = product.handle === 'cloak-black' || product.handle === 'black-xl' || isBaseColor(product);
    if (isBlackProduct) {
      return false;
    }
    
    // Check if explicitly marked as out of stock in JSON data
    if (product.out_of_stock === true) {
      return true;
    }
    
    // Use Shopify's built-in available check
    if (product.available === false) {
      return true;
    }
    
    // Check if any variant is available (Shopify's variant.available handles all inventory logic)
    if (product.variants && product.variants.length > 0) {
      const hasAvailableVariant = product.variants.some(variant => variant.available === true);
      return !hasAvailableVariant;
    }
    
    // Default to available if we can't determine
    return false;
  }
  
  function renderColorProductItem(product, colorIndex) {
    const isActive = product.id === currentProductId || product.id.toString() === currentProductId.toString() ? ' active' : '';
    const isOutOfStock = isProductOutOfStock(product);
    const outOfStockClass = isOutOfStock ? ' out-of-stock' : '';
    const outOfStockAttr = isOutOfStock ? ' data-out-of-stock="true"' : '';
    
    // Get image URL - handle different product data structures
    let imageUrl = '';
    if (product.featured_image) {
      imageUrl = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.src || product.featured_image);
    } else if (product.images && product.images.length > 0) {
      imageUrl = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || product.images[0]);
    } else if (product.image) {
      imageUrl = typeof product.image === 'string' ? product.image : (product.image.src || product.image);
    }
    
    // Ensure image URL is full URL if it's relative
    if (imageUrl && !imageUrl.startsWith('http') && !imageUrl.startsWith('//')) {
      if (imageUrl.startsWith('/')) {
        imageUrl = window.location.origin + imageUrl;
      } else {
        imageUrl = 'https:' + imageUrl;
      }
    }
    
    const productHandle = product.handle || product.id;
    const productTitle = product.title || 'Color Option';
    
    const imageHtml = imageUrl 
      ? `<img src="${imageUrl}" alt="${productTitle.replace(/"/g, '&quot;')}" class="cloak-color-image" loading="lazy" width="200" height="200">`
      : `<div class="cloak-color-image" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;"><span style="font-size: 0.75rem; color: #666;">No Image</span></div>`;
    
    const outOfStockX = isOutOfStock ? '<div class="cloak-color-out-of-stock-x"></div>' : '';
    const isBlackProduct = product.handle === 'cloak-black' || product.handle === 'black-xl' || isBaseColor(product);
    const priceAdj = getColorPriceAdjustment(product.handle);
    const priceAdjustment = priceAdj === 0 ? '' : `<div class="color-price-adjustment" style="pointer-events: none;">+$${(priceAdj/100).toFixed(2)}</div>`;
    
    return `
        <div class="cloak-color-item${isActive}${outOfStockClass}" data-color-index="${colorIndex}" data-product-id="${product.id}" data-handle="${productHandle}"${outOfStockAttr}>
        <div class="cloak-color-clickable" style="width: 100%; height: 100%; display: block; cursor: ${isOutOfStock ? 'not-allowed' : 'pointer'};">
          ${imageHtml}
          ${outOfStockX}
          <div class="cloak-color-title" style="pointer-events: none;">${productTitle}</div>
          ${priceAdjustment}
        </div>
      </div>
    `;
  }
  
  async function addColorProductToCart(colorProduct) {
    console.log('[Cloak Color] addColorProductToCart: Called with', colorProduct?.handle || colorProduct?.id);
    if (!colorProduct) {
      console.log('[Cloak Color] addColorProductToCart: No color product provided');
      return;
    }
    
    // Prevent adding out-of-stock items
    if (isProductOutOfStock(colorProduct)) {
      console.log('[Cloak Color] addColorProductToCart: Product is out of stock');
      return;
    }
    
    // Get the main product key we're adding a shell for
    const mainProductKey = window.latestMainProductKey;

    console.log('[Cloak Color] addColorProductToCart: Starting to add color product for main product', mainProductKey);
    
    try {
      
      // SKU mapping for color products
      const colorSkus = {
        'cloak-black': '100401',
        'black': '100401',
        'black-xl': '300037',
        'safety yellow': '102010',
        'arctic white': '102011',
        'arctic': '102011',
        'recon haze topo': '102017',
        'cloak-recon-haze-topo': '102017'
      };
      
        // Ensure we have the color product with variants
        let productWithVariants = colorProduct;
        if (!productWithVariants.variants || productWithVariants.variants.length === 0) {
          // Try to fetch the full product data with variants
          const productHandle = productWithVariants.handle || productWithVariants.id;
          const response = await fetch(`/products/${productHandle}.js`);
          if (response.ok) {
            productWithVariants = await response.json();
            window.selectedColorProduct = productWithVariants;
          } else {
            if (mainProductKey && window.addingColorUpgrades) {
              window.addingColorUpgrades.delete(mainProductKey);
            }
            return;
          }
        }
      
      // Add the color product (shell upgrade) as a separate line item
      if (productWithVariants && productWithVariants.variants && productWithVariants.variants.length > 0) {
        // Find variant by SKU based on product handle or title
        const productHandle = (productWithVariants.handle || '').toLowerCase();
        const productTitle = (productWithVariants.title || '').toLowerCase();
        let targetSku = null;
        
        // Check handle first (more reliable)
        if (productHandle && colorSkus[productHandle]) {
          targetSku = colorSkus[productHandle];
        } else {
          // Fallback to title matching
        for (const [key, sku] of Object.entries(colorSkus)) {
          if (productTitle.includes(key)) {
            targetSku = sku;
            break;
            }
          }
        }
        
          let colorVariant = null;
          if (targetSku) {
            // Find variant by SKU
            colorVariant = productWithVariants.variants.find(v => v.sku === targetSku);
          }
          
          // Fallback to first variant if SKU not found
          if (!colorVariant) {
            colorVariant = productWithVariants.variants[0];
          }
          
          const colorVariantId = colorVariant.id;
        const isBlackProduct = productHandle === 'cloak-black' || productHandle === 'black-xl' || isBaseColor(productWithVariants);
        
        // Get the main product's cart item key to link the color shell to it
        // This allows us to remove the color shell when the main product is removed
        // Use the mainProductKey we already have from the check above, or the stored latest main product key
        // Otherwise find the most recently added main product
        let mainProductCartKey = mainProductKey || window.latestMainProductKey || null;
        
        if (!mainProductCartKey) {
          try {
            const cartResponse = await fetch('/cart.js?t=' + Date.now());
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              // Find all main products in cart (currentProductId) and get the last one (most recently added)
              const mainProductItems = cart.items.filter(item =>
                item.product_id && item.product_id.toString() === currentProductId.toString()
              );
              // Get the first item (most recently added) - this is the one we just added
              if (mainProductItems.length > 0) {
                const mainProductItem = mainProductItems[0];
                mainProductCartKey = mainProductItem.key;
              }
            }
          } catch (error) {
            // If we can't get the cart key, continue without it
          }
        }
        
        // Don't clear the stored key yet - we need it for the shell addition
        // It will be cleared after the shell is successfully added
        
        // For black, don't add as upgrade (it's the base, no charge)
        // For other colors, add as upgrade
        // Add a unique identifier for tracking in localStorage (not sent to cart)
        // Use a combination of timestamp, random string, and main product key to ensure uniqueness
        const timestamp = Date.now();
        const randomStr = Math.random().toString(36).substr(2, 9);
        const uniqueId = mainProductCartKey ? `${mainProductCartKey}-${timestamp}-${randomStr}` : `instance-${timestamp}-${randomStr}`;

        // Include _upgrade and _main_product_key in properties to ensure Shopify
        // does not merge identical color shell items linked to different holsters.
        const isUpgrade = !!mainProductCartKey;
        const priceAdj = getColorPriceAdjustment(productHandle);
        const displayPrice = isUpgrade ? priceAdj : (3249 + priceAdj);

        const properties = isBlackProduct ? {
          '_main_product_key': mainProductCartKey || '',
          '_display_price': displayPrice.toString()
        } : {
          '_upgrade': 'Shell Color Upgrade',
          '_main_product_key': mainProductCartKey || '',
          '_display_price': displayPrice.toString()
        };

        console.log('[Cloak Color] addColorProductToCart: Adding variant', colorVariantId);
        console.log('[Cloak Color] addColorProductToCart: Main product cart key:', mainProductCartKey);
        console.log('[Cloak Color] addColorProductToCart: Unique instance ID:', uniqueId);

        // Mark that we're adding a color upgrade to prevent cleanup from removing it
        // Use a simple unique token for this addition attempt
        if (!window.addingColorUpgrades) {
          window.addingColorUpgrades = new Set();
        }
        const additionToken = `color-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        window.addingColorUpgrades.add(additionToken);
        console.log('[Cloak Color] addColorProductToCart: Set addingColorUpgrades with token:', additionToken);

        try {
        const colorResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: colorVariantId,
            quantity: 1,
              properties: properties
          })
        });
        
          if (!colorResponse.ok) {
            const errorText = await colorResponse.text();
            console.error('[Cloak Color] addColorProductToCart: Failed to add color product:', errorText);
            try {
              const errorData = JSON.parse(errorText);
              console.error('[Cloak Color] addColorProductToCart: Error details:', errorData);
            } catch (e) {
              console.error('[Cloak Color] addColorProductToCart: Error response is not JSON');
            }
            // Clear the flag on error
            if (window.addingColorUpgrades) {
              window.addingColorUpgrades.delete(additionToken);
              console.log('[Cloak Color] addColorProductToCart: Cleared addingColorUpgrades for token:', additionToken, '(error)');
            }
            return;
          }
          
            const cartData = await colorResponse.json();
          console.log('[Cloak Color] addColorProductToCart: Successfully added color product to cart');
          console.log('[Cloak Color] addColorProductToCart: Cart now has', cartData.items?.length || 0, 'items');

          // Clear the addingColorUpgrades flag after successful addition (with a small delay)
          setTimeout(() => {
            if (window.addingColorUpgrades) {
              window.addingColorUpgrades.delete(additionToken);
              console.log('[Cloak Color] addColorProductToCart: Cleared addingColorUpgrades for token:', additionToken);
            }
          }, 500);

          // Clear the stored key after successful addition
          window.latestMainProductKey = null;

          // Store metadata in localStorage for the newly added color shell
          // /cart/add.js returns the added item directly (not a full cart with items array)
          // Check if cartData itself is the newly added item, or check cartData.items for full cart response
          let newlyAddedItem = null;
          let metadataStored = false;

          // /cart/add.js returns the item directly - check if cartData is the item
          try {
            if (cartData && cartData.variant_id === colorVariantId && cartData.key) {
              newlyAddedItem = cartData;
              setColorShellMetadata(newlyAddedItem.key, mainProductCartKey, uniqueId, timestamp);
              console.log('[Cloak Color] addColorProductToCart: Stored metadata for new color shell (from add response):', newlyAddedItem.key);
              metadataStored = true;
            } else if (cartData && cartData.items) {
              // Some responses include full cart with items
              const foundItem = cartData.items.find(item => item.variant_id === colorVariantId);
              if (foundItem) {
                newlyAddedItem = foundItem;
                setColorShellMetadata(newlyAddedItem.key, mainProductCartKey, uniqueId, timestamp);
                console.log('[Cloak Color] addColorProductToCart: Stored metadata for new color shell (from cartData.items):', newlyAddedItem.key);
                metadataStored = true;
              }
            }
          } catch (e) {
            console.warn('[Cloak Color] addColorProductToCart: Error storing metadata from add response:', e);
          }

          // If not found in direct response, fetch the cart and retry a few times
          if (!metadataStored) {
            for (let retryAttempt = 0; retryAttempt < 5; retryAttempt++) {
              try {
                // Add a small delay before retrying (except on first attempt)
                if (retryAttempt > 0) {
                  await new Promise(resolve => setTimeout(resolve, 100));
                }

                const freshCartResponse = await fetch('/cart.js');
                if (freshCartResponse.ok) {
                  const freshCart = await freshCartResponse.json();
                  // Find the newly added item by matching the variant ID (should be the last one with that variant)
                  newlyAddedItem = freshCart.items?.find(item => item.variant_id === colorVariantId);
                  if (newlyAddedItem) {
                    setColorShellMetadata(newlyAddedItem.key, mainProductCartKey, uniqueId, timestamp);
                    console.log('[Cloak Color] addColorProductToCart: Stored metadata for new color shell (from /cart.js attempt', retryAttempt + 1, '):', newlyAddedItem.key);
                    metadataStored = true;
                    break;
                  }
                }
              } catch (metadataError) {
                console.warn('[Cloak Color] addColorProductToCart: Error storing metadata (attempt', retryAttempt + 1, '):', metadataError);
              }
            }
          }

          if (!metadataStored) {
            console.warn('[Cloak Color] addColorProductToCart: Could not find newly added color shell - shell may be removed as orphaned');
          }

          // Log all color shells in cart after addition (using localStorage for metadata now)
          const colorShellsAfter = cartData.items?.filter(item => isColorShellItem(item)) || [];
          console.log('[Cloak Color] addColorProductToCart: Color shells in cart after addition:', colorShellsAfter.map(item => ({
            key: item.key,
            title: item.title,
            variant_id: item.variant_id,
            main_product_key: getColorShellMainProductKey(item.key)
          })));

          // If metadata wasn't stored yet, wait a bit longer before publishing cartUpdate
          // This ensures cleanup doesn't remove the shell before metadata is ready
          if (!metadataStored) {
            console.log('[Cloak Color] addColorProductToCart: Metadata not stored yet, waiting before publishing cartUpdate...');
            await new Promise(resolve => setTimeout(resolve, 300));
          }

          // Refresh the cart UI using helper function
          await refreshCartUI(cartData);
          
          // Update cart notification heading if it exists
          const cartNotification = document.querySelector('cart-notification');
          if (cartNotification) {
            const notificationHeading = cartNotification.querySelector('.cart-notification__heading');
            if (notificationHeading) {
              const headingText = notificationHeading.textContent || '';
              if (!headingText.includes('2') && !headingText.includes('two')) {
                notificationHeading.innerHTML = notificationHeading.innerHTML.replace(
                  /Item added to your cart/i,
                  '2 items added to your cart'
                );
              }
            }
          }
        } catch (innerError) {
          console.error('[Cloak Color] addColorProductToCart: Error in inner try block:', innerError);
          // Clear the flag on error
          if (window.addingColorUpgrades) {
            window.addingColorUpgrades.delete(additionToken);
            console.log('[Cloak Color] addColorProductToCart: Cleared addingColorUpgrades for token:', additionToken, '(inner error)');
          }
        }
      }
    } catch (error) {
      console.error('[Cloak Color] addColorProductToCart: Error adding color upgrade', error);
      // Clear the flag on error
      if (window.addingColorUpgrades) {
        window.addingColorUpgrades.delete(additionToken);
        console.log('[Cloak Color] addColorProductToCart: Cleared addingColorUpgrades for token:', additionToken, '(outer error)');
      }
    }
  }
  
  const xlBoltaronCodes = ['1039', '1047', '0992', '1058', '1165', '1141', '1276', '1040', '1067'];
  
  function isXLBoltaronSku(sku) {
    if (!sku) return false;
    const parts = sku.split('-');
    return parts.length > 1 && xlBoltaronCodes.indexOf(parts[1]) !== -1;
  }

  function getItemSku(item) {
    if (!item) return null;
    if (item.sku) return item.sku;
    if (item.properties) {
      if (typeof item.properties === 'object') {
        return item.properties._sku || item.properties.SKU || item.properties._SKU || null;
      } else if (Array.isArray(item.properties)) {
        const prop = item.properties.find(p => p.name === '_sku' || p.name === 'SKU' || p.name === '_SKU');
        return prop ? prop.value : null;
      }
    }
    return null;
  }

  function getBlackProductHandleForCartItem(item) {
    const itemSku = getItemSku(item);
    if (itemSku && isXLBoltaronSku(itemSku)) {
      return 'black-xl';
    }
    const skuContainer = document.querySelector('.product__sku--value');
    if (skuContainer && skuContainer.textContent) {
      if (isXLBoltaronSku(skuContainer.textContent.trim())) {
        return 'black-xl';
      }
    }
    return 'cloak-black';
  }
  
  function getBlackProductHandleForCart(cartData) {
    if (!cartData) return getBlackProductHandleForCartItem();
    
    // If cartData has items array
    if (cartData.items && cartData.items.length > 0) {
      const mainProduct = cartData.items.find(item => {
        if (!isEligibleMainProduct(item)) return false;
        if (item.properties && item.properties._no_shell_addon === 'true') return false;
        return true;
      });
      if (mainProduct) {
        return getBlackProductHandleForCartItem(mainProduct);
      }
    }
    
    // If cartData itself is a single line item
    const itemSku = getItemSku(cartData);
    if (itemSku) {
      return getBlackProductHandleForCartItem(cartData);
    }
    
    return getBlackProductHandleForCartItem();
  }

  // Check if an item is a color shell
  function isColorShellItem(item) {
    if (!item) return false;
    
    // Check if item has _upgrade property
    if (item.properties) {
      if (Array.isArray(item.properties)) {
        const upgradeProp = item.properties.find(prop => prop.name === '_upgrade');
        if (upgradeProp && upgradeProp.value) {
          return true;
        }
      } else if (typeof item.properties === 'object' && item.properties._upgrade) {
        return true;
      }
    }
    
    // Check by SKU (color products have specific SKUs)
    const sku = item.sku || '';
    const isColorSku = sku === '102010' || sku === '102011' || sku === '102017' || sku === '100401' || sku === '300037' ||
                      sku.startsWith('1020') || sku.startsWith('1004') || sku.startsWith('3000');
    
    // Check by product handle - only match known color product handles
    // Color shells have specific handles from the colorProductIds array
    const handle = (item.handle || '').toLowerCase();
    
    // Known color product handles (from colorProductIds)
    const knownColorHandles = [
      'cloak-black',
      'black-xl',
      'cloak-recon-haze-topo',
      'cloak-mc-alpine',
      'cloak-mc-arid',
      'cloak-mc-tropic',
      'cloak-mc-black',
      'cloak-arctic-white',
      'cloak-safety-yellow',
      'cloak-neon-pink',
      'cloak-safety-orange',
      'cloak-purple',
      'cloak-police-blue',
      'cloak-army-green',
      'cloak-black-carbon-fiber',
      'cloak-dark-grey'
    ];
    
    // Check if handle matches a known color product handle
    const isColorHandle = knownColorHandles.includes(handle);
    
    // Also check if this is the current main product - if so, it's NOT a color shell
    if (currentProductId && item.product_id) {
      const isMainProduct = item.product_id.toString() === currentProductId.toString();
      if (isMainProduct) {
        return false; // Main product is never a color shell
      }
    }
    
    return isColorSku || isColorHandle;
  }
  window.isColorShellItem = isColorShellItem;
  
  // Only Cloak, Low-Pro and the bag bundle take color shells (allowlist by handle)
  function isShellEligibleHandle(handle) {
    handle = (handle || '').toLowerCase();
    if (handle.includes('mag-carrier')) return false;
    // Parts and holster bases have no shell picker and never take a shell
    if (handle.includes('replacement-parts') || handle.includes('holster-base')) return false;
    return handle.startsWith('cloak-') || handle.startsWith('low-pro-') || handle === 'bag-bundle';
  }
  window.isShellEligibleHandle = isShellEligibleHandle;

  // Check if an item is an eligible main product that can have a color shell
  function isEligibleMainProduct(item) {
    if (!item) return false;
    if (isColorShellItem(item)) return false;
    return isShellEligibleHandle(item.handle);
  }
  window.isEligibleMainProduct = isEligibleMainProduct;
  
  // Check if a SKU matches a color shell SKU
  function isColorShellSku(sku) {
    if (!sku) return false;
    const skuStr = sku.toString();
    return skuStr === '102010' || skuStr === '102011' || skuStr === '102017' || skuStr === '100401' || skuStr === '300037' ||
           skuStr.startsWith('1020') || skuStr.startsWith('1004') || skuStr.startsWith('3000');
  }
  
  // Helper to find the quantity of the linked holster for a color shell
  function getLinkedHolsterQuantity(colorShell, cart) {
    if (!colorShell || !cart) return 1;
    let mainProductKey = null;
    if (colorShell.properties) {
      if (Array.isArray(colorShell.properties)) {
        const prop = colorShell.properties.find(p => p.name === '_main_product_key');
        mainProductKey = prop ? prop.value : null;
      } else if (typeof colorShell.properties === 'object') {
        mainProductKey = colorShell.properties._main_product_key || null;
      }
    }
    if (!mainProductKey) {
      try {
        const localData = localStorage.getItem('cloak-color-shell-metadata');
        if (localData) {
          const metadata = JSON.parse(localData);
          mainProductKey = metadata[colorShell.key]?.mainProductKey || null;
        }
      } catch (e) {}
    }
    if (!mainProductKey && typeof getColorShellMainProductKey === 'function') {
      mainProductKey = getColorShellMainProductKey(colorShell.key);
    }
    
    if (mainProductKey) {
      const linkedHolster = cart.items.find(h => h.key === mainProductKey || `${h.product_id}:${h.variant_id}` === mainProductKey);
      if (linkedHolster) {
        return linkedHolster.quantity;
      }
    }
    
    // Fallback: use first holster
    const holsterItems = cart.items.filter(item => isEligibleMainProduct(item));
    if (holsterItems.length > 0) {
      return holsterItems[0].quantity;
    }
    return 1;
  }

  // Prevent quantity increments for color shell items in cart
  function preventColorShellQuantityIncrement() {
    // Get current cart to check SKUs
    fetch('/cart.js?t=' + Date.now())
      .then(response => {
        if (!response.ok) return;
        return response.json();
      })
      .then(cart => {
        if (!cart) return;
        // Find all quantity inputs in cart
        const quantityInputs = document.querySelectorAll('.cart-item .quantity__input, cart-drawer .quantity__input, [data-quantity-variant-id]');
        
        quantityInputs.forEach(input => {
          // Get the cart item this input belongs to
          const cartItem = input.closest('.cart-item, [data-cart-item]');
          if (!cartItem) return;
          
          // Try to find the SKU from the cart item
          // Check data attributes, text content, or cart data
          const itemIndex = input.getAttribute('data-index') || 
                           input.getAttribute('id')?.match(/(\d+)/)?.[1];
          
          let isColorShell = false;
          let cartItemData = null;
          
          if (itemIndex) {
            const cartItemIndex = parseInt(itemIndex) - 1;
            if (cart.items && cart.items[cartItemIndex]) {
              cartItemData = cart.items[cartItemIndex];
              isColorShell = isColorShellItem(cartItemData);
            }
          }
          
          // Also check by SKU in the input's data attributes or nearby elements
          if (!isColorShell) {
            const variantId = input.getAttribute('data-quantity-variant-id');
            if (variantId && cart.items) {
              cartItemData = cart.items.find(item => 
                item.variant_id && item.variant_id.toString() === variantId.toString()
              );
              if (cartItemData) {
                isColorShell = isColorShellItem(cartItemData);
              }
            }
          }
          
          // Check text content for SKU
          if (!isColorShell) {
            const itemText = cartItem.textContent || '';
            if (itemText.includes('SKU: 102010') || itemText.includes('SKU: 102011') || 
                itemText.includes('SKU: 102017') || itemText.includes('SKU: 100401') || 
                itemText.includes('Shell Color Upgrade')) {
              isColorShell = true;
            }
          }
          
          if (isColorShell) {
            const expectedQty = getLinkedHolsterQuantity(cartItemData, cart);
            
            // Set max to expectedQty and disable plus/minus buttons
            input.setAttribute('max', expectedQty.toString());
            input.max = expectedQty;
            const currentValue = parseInt(input.value) || expectedQty;
            if (currentValue !== expectedQty) {
              input.value = expectedQty;
              // Force update the cart to set quantity back to expectedQty
              if (itemIndex) {
                const cartItems = input.closest('cart-items, cart-drawer-items') || document.querySelector('cart-items, cart-drawer-items');
                if (cartItems && cartItems.updateQuantity) {
                  cartItems.updateQuantity(parseInt(itemIndex), expectedQty);
                }
              }
            }
            
            // Disable plus button
            const plusButton = cartItem.querySelector('.quantity__button[name="plus"], button[name="plus"]');
            if (plusButton) {
              plusButton.disabled = true;
              plusButton.classList.add('disabled');
              plusButton.style.pointerEvents = 'none';
              plusButton.style.opacity = '0.5';
              plusButton.setAttribute('aria-disabled', 'true');
            }
            
            // Disable minus button
            const minusButton = cartItem.querySelector('.quantity__button[name="minus"], button[name="minus"]');
            if (minusButton) {
              minusButton.disabled = true;
              minusButton.classList.add('disabled');
              minusButton.style.pointerEvents = 'none';
              minusButton.style.opacity = '0.5';
              minusButton.setAttribute('aria-disabled', 'true');
            }
            
            // Also prevent manual input changes
            const changeHandler = function(e) {
              const value = parseInt(e.target.value);
              if (value !== expectedQty) {
                e.target.value = expectedQty;
                e.preventDefault();
                e.stopPropagation();
                // Force update cart
                if (itemIndex) {
                  const cartItems = input.closest('cart-items, cart-drawer-items') || document.querySelector('cart-items, cart-drawer-items');
                  if (cartItems && cartItems.updateQuantity) {
                    cartItems.updateQuantity(parseInt(itemIndex), expectedQty);
                  }
                }
                return false;
              }
            };
            // Remove old listener and add new one
            input.removeEventListener('change', changeHandler);
            input.addEventListener('change', changeHandler);
            
            // Prevent stepUp
            if (!input._originalStepUp) {
              input._originalStepUp = input.stepUp;
            }
            input.stepUp = function() {
              return; // Don't increment
            };
            
            // Prevent stepDown
            if (!input._originalStepDown) {
              input._originalStepDown = input.stepDown;
            }
            input.stepDown = function() {
              return; // Don't decrement
            };
          }
        });
      })
      .catch(error => {
        console.error('[Cloak Color] Error preventing color shell quantity increment:', error);
      });
  }
  
  // Intercept CartItems.updateQuantity to prevent color shell quantity changes
  function interceptCartQuantityUpdates() {
    const cartItemsElements = document.querySelectorAll('cart-items, cart-drawer-items');
    cartItemsElements.forEach(cartItems => {
      if (cartItems._quantityUpdateIntercepted) return;
      cartItems._quantityUpdateIntercepted = true;
      
      const originalUpdateQuantity = cartItems.updateQuantity.bind(cartItems);
      cartItems.updateQuantity = async function(line, quantity, name, variantId) {
        console.log('[Cloak Color] interceptCartQuantityUpdates: updateQuantity called', line, quantity);
        
        // Get current cart to check if this is a color shell
        try {
          const cartResponse = await fetch('/cart.js?t=' + Date.now());
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            const itemIndex = parseInt(line) - 1;
            
            if (cart.items && cart.items[itemIndex]) {
              const item = cart.items[itemIndex];
              const isColorShell = isColorShellItem(item);
              
              if (isColorShell) {
                const expectedQty = getLinkedHolsterQuantity(item, cart);
                
                // Allow quantity of 0 for deletion, but block any other quantity different from expectedQty
                if (quantity !== 0 && quantity !== expectedQty) {
                  console.log(`[Cloak Color] interceptCartQuantityUpdates: Blocking quantity change for color shell ${item.sku} - forcing to ${expectedQty}`);
                  return originalUpdateQuantity.call(this, line, expectedQty, name, variantId);
                }
                
                // If deleting, set global flags to trigger holster removal
                if (quantity === 0) {
                  console.log('[Cloak Color] interceptCartQuantityUpdates: Deleting color shell', item.sku);
                  let mainProductKey = null;
                  if (item.properties) {
                    if (Array.isArray(item.properties)) {
                      const mainProductProp = item.properties.find(prop => prop.name === '_main_product_key');
                      mainProductKey = mainProductProp ? mainProductProp.value : null;
                    } else if (typeof item.properties === 'object') {
                      mainProductKey = item.properties._main_product_key || null;
                    }
                  }
                  if (!mainProductKey && typeof getColorShellMainProductKey === 'function') {
                    mainProductKey = getColorShellMainProductKey(item.key);
                  }
                  if (mainProductKey) {
                    window.shellBeingRemoved = true;
                    window.deletedMainProductKey = mainProductKey;
                    console.log('[Cloak Color] interceptCartQuantityUpdates: Shell being removed. Linked holster key:', mainProductKey);
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('[Cloak Color] interceptCartQuantityUpdates: Error checking cart', error);
        }
        
        // Allow normal update for non-color-shell items
        return originalUpdateQuantity.call(this, line, quantity, name, variantId);
      };
    });
  }
  
  // Clean up color shells when their associated main products are removed
  // Also ensures color shells cannot exist in cart by themselves
  // Enforces one color shell per main product
  // Expose globally so cart.js can call it
  window.cleanupOrphanedColorShells = async function cleanupOrphanedColorShells(optionalCart = null) {
    console.log('[Cloak Color] cleanupOrphanedColorShells: Starting cleanup...');
    
    // Don't run cleanup if we're currently adding color upgrades
    if (window.addingColorUpgrades && window.addingColorUpgrades.size > 0) {
      console.log('[Cloak Color] cleanupOrphanedColorShells: Skipping cleanup - color upgrades are being added');
      return;
    }

    // Don't run cleanup if we're currently removing upgrades/holsters to prevent adding default shells back
    if (window.shellBeingRemoved || window.holsterBeingRemoved) {
      console.log('[Cloak Color] cleanupOrphanedColorShells: Skipping cleanup - item removal in progress');
      return;
    }
    
    try {
      let cart = optionalCart;
      if (!cart) {
        const cartResponse = await fetch('/cart.js?t=' + Date.now());
        if (!cartResponse.ok) {
          console.log('[Cloak Color] cleanupOrphanedColorShells: Failed to fetch cart');
          return;
        }
        cart = await cartResponse.json();
      }
      console.log('[Cloak Color] cleanupOrphanedColorShells: Cart has', cart.items.length, 'items');
      
      // Find all color shell items
      const colorShellItems = cart.items.filter(item => isColorShellItem(item));
      console.log('[Cloak Color] cleanupOrphanedColorShells: Found', colorShellItems.length, 'color shell items');
      
      // Find all eligible main products (holsters / bag bundles)
      const holsterItems = cart.items.filter(item => isEligibleMainProduct(item));
      
      console.log('[Cloak Color] Holsters in cart:', holsterItems.map(h => ({ key: h.key, qty: h.quantity })));
      console.log('[Cloak Color] Shells in cart:', colorShellItems.map(s => ({ key: s.key, qty: s.quantity })));
      
      // If there are no holsters in the cart, remove ALL shells
      if (holsterItems.length === 0) {
        if (colorShellItems.length > 0) {
          console.log('[Cloak Color] No holsters in cart, removing all shells');
          for (const shell of colorShellItems) {
            await removeCartItem(shell.key);
            await new Promise(resolve => setTimeout(resolve, 200));
          }
        }
        return;
      }
      
      // Keep track of which shells are linked to which holster
      const shellsByHolster = new Map();
      const orphanedShells = [];
      
      for (const colorShell of colorShellItems) {
        // Read main product key from properties or localStorage
        let mainProductKey = null;
        if (colorShell.properties) {
          if (Array.isArray(colorShell.properties)) {
            const prop = colorShell.properties.find(p => p.name === '_main_product_key');
            mainProductKey = prop ? prop.value : null;
          } else if (typeof colorShell.properties === 'object') {
            mainProductKey = colorShell.properties._main_product_key || null;
          }
        }
        if (!mainProductKey) {
          mainProductKey = getColorShellMainProductKey(colorShell.key);
        }
        
        // Find if this key belongs to an active holster in the cart
        let linkedHolster = null;
        if (mainProductKey) {
          linkedHolster = holsterItems.find(h => h.key === mainProductKey || `${h.product_id}:${h.variant_id}` === mainProductKey);
        }
        
        // Fallback: link to the first holster if not linked but holsters exist
        if (!linkedHolster && holsterItems.length > 0) {
          linkedHolster = holsterItems[0];
          mainProductKey = linkedHolster.key;
        }
        
        if (linkedHolster) {
          const key = linkedHolster.key;
          if (!shellsByHolster.has(key)) {
            shellsByHolster.set(key, []);
          }
          shellsByHolster.get(key).push(colorShell);
        } else {
          orphanedShells.push(colorShell);
        }
      }
      
      let cartChanged = false;
      let latestCart = cart;
      
      // Remove orphaned shells
      if (orphanedShells.length > 0) {
        console.log('[Cloak Color] Removing orphaned shells:', orphanedShells.map(s => s.key));
        for (const shell of orphanedShells) {
          await removeCartItem(shell.key);
          cartChanged = true;
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        // Fetch fresh cart after deletions
        latestCart = await fetch('/cart.js?t=' + Date.now()).then(r => r.json());
      }
      
      // Sync quantities for each holster
      for (const holster of holsterItems) {
        const linkedShells = shellsByHolster.get(holster.key) || [];
        const totalShellQty = linkedShells.reduce((sum, s) => sum + s.quantity, 0);
        
        console.log(`[Cloak Color] Holster ${holster.key} has quantity ${holster.quantity}, linked shells total quantity ${totalShellQty}`);
        
        if (linkedShells.length === 0) {
          // Add a missing shell with quantity matching holster
          console.log(`[Cloak Color] No shells linked to holster ${holster.key}. Adding one with quantity ${holster.quantity}`);
          
          let variantIdToAdd = null;
          let templateHandle = null;
          if (colorShellItems.length > 0) {
            variantIdToAdd = colorShellItems[0].variant_id;
            templateHandle = colorShellItems[0].handle;
          } else if (window.selectedColorProduct?.variants?.[0]?.id) {
            variantIdToAdd = window.selectedColorProduct.variants[0].id;
          }
          
          if (variantIdToAdd) {
            const timestamp = Date.now();
            const uniqueId = `${holster.key}-${timestamp}`;
            const priceAdj = getColorPriceAdjustment(templateHandle);
            const properties = {
              '_main_product_key': holster.key,
              '_display_price': priceAdj.toString()
            };
            if (templateHandle && templateHandle !== 'cloak-black') {
              properties['_upgrade'] = 'Shell Color Upgrade';
            }
            
            if (!window.addingColorUpgrades) {
              window.addingColorUpgrades = new Set();
            }
            window.addingColorUpgrades.add(holster.key);
            
            try {
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: variantIdToAdd,
                  quantity: holster.quantity,
                  properties: properties
                })
              });
              if (res.ok) {
                latestCart = await res.json();
                cartChanged = true;
                const newShell = latestCart.items?.find(item => item.variant_id === variantIdToAdd);
                if (newShell) {
                  setColorShellMetadata(newShell.key, holster.key, uniqueId, timestamp);
                }
              }
            } catch (e) {
              console.error('[Cloak Color] Error adding missing shell:', e);
            } finally {
              window.addingColorUpgrades.delete(holster.key);
            }
          }
        } else {
          // Shells are linked. Check if total quantity matches holster.
          if (totalShellQty !== holster.quantity) {
            console.log(`[Cloak Color] Quantities out of sync for holster ${holster.key}. Syncing...`);
            const primaryShell = linkedShells[0];
            
            // Set primary shell quantity to holster.quantity using the unique key directly
            try {
              const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: primaryShell.key,
                  quantity: holster.quantity
                })
              });
              if (res.ok) {
                latestCart = await res.json();
                cartChanged = true;
              }
            } catch (e) {
              console.error('[Cloak Color] Error updating shell quantity:', e);
            }
            
            // Remove any other extra linked shells
            for (let i = 1; i < linkedShells.length; i++) {
              await removeCartItem(linkedShells[i].key);
              cartChanged = true;
              await new Promise(resolve => setTimeout(resolve, 200));
            }
            
            if (linkedShells.length > 1) {
              latestCart = await fetch('/cart.js?t=' + Date.now()).then(r => r.json());
            }
          }
        }
      }
      
      if (cartChanged && latestCart) {
        await refreshCartUI(latestCart);
      }
      console.log('[Cloak Color] cleanupOrphanedColorShells: Cleanup complete');
    } catch (error) {
      console.error('[Cloak Color] cleanupOrphanedColorShells: Error cleaning up orphaned color shells:', error);
      console.error('[Cloak Color] cleanupOrphanedColorShells: Error stack:', error.stack);
    }
  };
  
  // Also create a local reference for internal use
  const cleanupOrphanedColorShells = window.cleanupOrphanedColorShells;
  
  // Handle quantity updates for color shell upgrades
  // If quantity > 1, split into 1 upgrade item + (qty-1) full price items
  async function handleColorShellQuantityUpdate(cartData) {
    try {
      const cart = cartData;
      
      // Find color shell upgrade items with quantity > 1
      const upgradeItems = cart.items.filter(item => {
        if (!isColorShellItem(item)) return false;
        // Must have _upgrade property to be an upgrade item
        if (!item.properties || !item.properties._upgrade) return false;
        // Quantity must be > 1
        return item.quantity > 1;
      });
      
      for (const upgradeItem of upgradeItems) {
        const quantity = upgradeItem.quantity;
        const variantId = upgradeItem.variant_id;
        // Get mainProductKey from localStorage instead of from properties
        const mainProductKey = getColorShellMainProductKey(upgradeItem.key);

        // Remove the upgrade item
        await removeCartItem(upgradeItem.key);

        // Wait a bit for removal to complete
        await new Promise(resolve => setTimeout(resolve, 200));

        // Add 1 upgrade item (at upgrade price) with main product key
        const priceAdj = getColorPriceAdjustment(upgradeItem.handle);
        const upgradeProperties = {
          '_upgrade': 'Shell Color Upgrade',
          '_main_product_key': mainProductKey || '',
          '_display_price': priceAdj.toString()
        };

        // Store the tracking info for when we re-add
        const timestamp = Date.now();
        const randomStr = Math.random().toString(36).substr(2, 9);
        const uniqueId = mainProductKey ? `${mainProductKey}-${timestamp}-${randomStr}` : `instance-${timestamp}-${randomStr}`;
        
        const upgradeResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: upgradeProperties
          })
        });

        // Store metadata for the re-added upgrade item
        if (upgradeResponse.ok) {
          const upgradeCartData = await upgradeResponse.json();
          const newUpgradeItem = upgradeCartData.items?.find(item => item.variant_id === variantId && item.properties?._upgrade);
          if (newUpgradeItem) {
            setColorShellMetadata(newUpgradeItem.key, mainProductKey, uniqueId, timestamp);
          }
        }

        // Add (quantity - 1) full price items (without upgrade property)
        if (quantity > 1) {
          const priceAdj = getColorPriceAdjustment(upgradeItem.handle);
          const fullPriceProperties = {
            '_display_price': (3249 + priceAdj).toString()
          };
          const fullPriceResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity - 1,
              properties: fullPriceProperties
            })
          });

          // Store metadata for the full price items (no upgrade property)
          if (fullPriceResponse.ok) {
            const fullPriceCartData = await fullPriceResponse.json();
            // Find the newly added full price items (they may be combined into one line)
            const fullPriceItems = fullPriceCartData.items?.filter(item =>
              item.variant_id === variantId && !item.properties?._upgrade
            );
            if (fullPriceItems) {
              // For full price items, still track the main product key in case they need cleanup
              fullPriceItems.forEach(item => {
                const fpTimestamp = Date.now();
                const fpRandomStr = Math.random().toString(36).substr(2, 9);
                const fpUniqueId = mainProductKey ? `${mainProductKey}-${fpTimestamp}-${fpRandomStr}` : `instance-${fpTimestamp}-${fpRandomStr}`;
                setColorShellMetadata(item.key, mainProductKey, fpUniqueId, fpTimestamp);
              });
            }
          }
        }

        // Trigger cart update
        const updatedCart = await fetch('/cart.js').then(r => r.json());
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'color-quantity-split',
            cartData: updatedCart
          });
        }
      }
    } catch (error) {
      console.error('Error handling color shell quantity update:', error);
    }
  }
  
  // Hide quantity controls on cloak-color product page
  function hideQuantityOnProductPage() {
    // Check if this is a cloak-color product page
    if (!currentProductId) {
      return;
    }
    
    // Check if current product handle is cloak-color
    // Also check if we're on a cloak-color page by looking for the cloak-colors-section
    const productHandle = window.location.pathname.match(/\/products\/([^\/\?#]+)/)?.[1];
    const hasCloakColorsSection = document.querySelector('.cloak-colors-section') !== null;
    
    // Check if this is a cloak-color page - either by handle or by presence of cloak-colors-section
    if (!hasCloakColorsSection && (!productHandle || !productHandle.includes('cloak-color'))) {
      return;
    }
    
    // Add class to body for CSS targeting
    document.body.classList.add('cloak-color-product-page');
    
    // Add CSS to hide quantity controls - use multiple approaches for maximum compatibility
    const styleId = 'cloak-color-hide-quantity';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      // Use :has() if supported, but also add direct selectors as fallback
      style.textContent = `
        /* Target all quantity controls on cloak-color pages */
        body.cloak-color-product-page .product-form__quantity,
        body.cloak-color-product-page #Quantity-Form-${sectionId},
        body.cloak-color-product-page quantity-input,
        body.cloak-color-product-page .quantity,
        body.cloak-color-product-page input[name="quantity"],
        body.cloak-color-product-page .quantity__input,
        body.cloak-color-product-page .quantity__button,
        body.cloak-color-product-page .quantity__label,
        body.cloak-color-product-page button[name="plus"],
        body.cloak-color-product-page button[name="minus"],
        body.cloak-color-product-page .price-per-item__container,
        /* Also target by ID patterns */
        body.cloak-color-product-page [id^="Quantity-Form-"],
        body.cloak-color-product-page [id^="Quantity-"]:not([id*="Rules"]):not([id*="cart"]) {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          height: 0 !important;
          width: 0 !important;
          overflow: hidden !important;
          position: absolute !important;
          left: -9999px !important;
          pointer-events: none !important;
        }
        /* Add margin above add to cart button on cloak-color pages */
        body.cloak-color-product-page .product-form__submit {
          margin-top: 1.5rem !important;
        }
      `;
      document.head.appendChild(style);
    }
    
    // Also try to find and hide elements directly
    const allQuantityInputs = document.querySelectorAll('input[name="quantity"], .quantity__input, input.quantity__input');
    allQuantityInputs.forEach(input => {
      input.style.setProperty('display', 'none', 'important');
      input.disabled = true;
      input.setAttribute('readonly', 'readonly');
      input.value = '1';
      input.setAttribute('aria-hidden', 'true');
    });
    
    const allQuantityButtons = document.querySelectorAll('.quantity__button, button[name="plus"], button[name="minus"]');
    allQuantityButtons.forEach(button => {
      button.style.setProperty('display', 'none', 'important');
      button.disabled = true;
      button.setAttribute('aria-hidden', 'true');
    });
    
    const allQuantityLabels = document.querySelectorAll('.quantity__label');
    allQuantityLabels.forEach(label => {
      label.style.setProperty('display', 'none', 'important');
    });
    
    // Hide entire quantity form sections
    const quantityForms = document.querySelectorAll('.product-form__quantity, #Quantity-Form-' + sectionId);
    quantityForms.forEach(form => {
      form.style.setProperty('display', 'none', 'important');
    });
    
    // Hide quantity-input custom elements
    const quantityInputElements = document.querySelectorAll('quantity-input');
    quantityInputElements.forEach(el => {
      el.style.setProperty('display', 'none', 'important');
    });
    
    // Also try to find by any ID containing "Quantity"
    const allQuantityElements = document.querySelectorAll('[id*="Quantity"]');
    allQuantityElements.forEach(el => {
      if (el.id && (el.id.includes('Quantity-Form') || el.id.includes('Quantity-'))) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }
  
  // Use MutationObserver to catch dynamically added quantity controls
  function observeQuantityControls() {
    // Check if this is a cloak-color product page
    if (!currentProductId) return;
    
    const productHandle = window.location.pathname.match(/\/products\/([^\/\?#]+)/)?.[1];
    const hasCloakColorsSection = document.querySelector('.cloak-colors-section') !== null;
    
    // Check if this is a cloak-color page - either by handle or by presence of cloak-colors-section
    if (!hasCloakColorsSection && (!productHandle || !productHandle.includes('cloak-color'))) {
      return;
    }
    
    // Observe for new quantity controls being added
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Check if it's a quantity-related element
            if (node.matches && (
              node.matches('.product-form__quantity') ||
              node.matches('quantity-input') ||
              node.matches('#Quantity-Form-' + sectionId) ||
              node.matches('.quantity') ||
              node.querySelector('.quantity__input') ||
              node.querySelector('input[name="quantity"]')
            )) {
              hideQuantityOnProductPage();
            }
            
            // Also check children
            const quantityInputs = node.querySelectorAll && node.querySelectorAll('input[name="quantity"], .quantity__input, .quantity__button, .quantity__label');
            if (quantityInputs && quantityInputs.length > 0) {
              hideQuantityOnProductPage();
            }
          }
        });
      });
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Enforce quantity of 1 for cloak-color items in cart
  async function enforceCloakColorQuantity(cartData) {
    try {
      const cart = cartData;
      
      // Find cloak-color items (main products, not color shells) with quantity > 1
      const cloakColorItems = cart.items.filter(item => {
        // Check if it's a cloak-color product (main product, not color shell)
        const itemHandle = item.handle || '';
        const isCloakColor = (itemHandle === 'cloak-color' || itemHandle.includes('cloak-color')) &&
                            !isColorShellItem(item);
        
        // Also check by product_id if available
        const isCloakColorById = currentProductId && 
                                item.product_id && 
                                item.product_id.toString() === currentProductId.toString() &&
                                !isColorShellItem(item);
        
        return (isCloakColor || isCloakColorById) && item.quantity > 1;
      });
      
      // Reset quantity to 1 for any cloak-color items with quantity > 1
      for (const cloakColorItem of cloakColorItems) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: cloakColorItem.key,
            quantity: 1
          })
        });
      }
      
      // Re-hide quantity controls after enforcing
      if (cloakColorItems.length > 0) {
        setTimeout(() => {
          hideQuantityForCloakColorInCart();
        }, 200);
      }
    } catch (error) {
      console.error('Error enforcing cloak-color quantity:', error);
    }
  }
  
  // Hide quantity controls for cloak-color items in cart
  async function hideQuantityForCloakColorInCart() {
    try {
      // Get current cart data to identify cloak-color items
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) return;
      
      const cart = await cartResponse.json();
      
      // Find all cloak-color items (main products, not color shells)
      const cloakColorItemKeys = new Set();
      cart.items.forEach(item => {
        // Check if it's a cloak-color product (main product, not color shell)
        const itemHandle = item.handle || '';
        const isCloakColor = (itemHandle === 'cloak-color' || itemHandle.includes('cloak-color')) &&
                            !isColorShellItem(item);
        
        // Also check by product_id if available (only on product page)
        const isCloakColorById = currentProductId && 
                                item.product_id && 
                                item.product_id.toString() === currentProductId.toString() &&
                                !isColorShellItem(item);
        
        if (isCloakColor || isCloakColorById) {
          cloakColorItemKeys.add(item.key);
        }
      });
      
      // Get all cart items in the DOM
      const cartItems = document.querySelectorAll('.cart-item, [data-cart-item]');
      
      cartItems.forEach(cartItem => {
        // Try to find the item index to match with cart data
        const quantityInput = cartItem.querySelector('.quantity__input, input[data-quantity-variant-id]');
        const itemIndex = quantityInput?.getAttribute('data-index') || 
                         quantityInput?.getAttribute('id')?.match(/(\d+)/)?.[1];
        
        // Check if this is a cloak-color item
        let isCloakColorItem = false;
        
        if (itemIndex) {
          // Try to find matching cart item by index
          const cartItemIndex = parseInt(itemIndex) - 1; // Cart items are 1-indexed
          if (cart.items[cartItemIndex]) {
            const cartItemData = cart.items[cartItemIndex];
            const itemHandle = cartItemData.handle || '';
            const isCloakColor = (itemHandle === 'cloak-color' || itemHandle.includes('cloak-color')) &&
                                !isColorShellItem(cartItemData);
            const isCloakColorById = currentProductId && 
                                    cartItemData.product_id && 
                                    cartItemData.product_id.toString() === currentProductId.toString() &&
                                    !isColorShellItem(cartItemData);
            isCloakColorItem = isCloakColor || (isCloakColorById && currentProductId);
          }
        }
        
        // Fallback: check by text content
        if (!isCloakColorItem) {
          const itemText = cartItem.textContent || '';
          const itemLink = cartItem.querySelector('a[href*="/products/"]');
          if (itemLink) {
            const href = itemLink.getAttribute('href') || '';
            const handle = href.match(/\/products\/([^\/\?#]+)/)?.[1];
            if (handle && (handle === 'cloak-color' || handle.includes('cloak-color'))) {
              // Make sure it's not a color shell
              const hasUpgradeText = itemText.includes('Shell Color Upgrade') || 
                                    itemText.includes('_upgrade');
              const hasColorSku = itemText.includes('SKU: 102010') || 
                                 itemText.includes('SKU: 102011') || 
                                 itemText.includes('SKU: 102017') || 
                                 itemText.includes('SKU: 100401');
              if (!hasUpgradeText && !hasColorSku) {
                isCloakColorItem = true;
              }
            }
          }
        }
        
        if (isCloakColorItem) {
          // Hide quantity controls for this item
          const quantityInput = cartItem.querySelector('.quantity__input, input[data-quantity-variant-id]');
          const quantityButtons = cartItem.querySelectorAll('.quantity__button, button[name="plus"], button[name="minus"]');
          const quantityWrapper = cartItem.querySelector('.quantity, .cart-item__quantity-wrapper, quantity-input');
          
          let qty = '1';
          if (cartItemData) {
            qty = cartItemData.quantity ? cartItemData.quantity.toString() : '1';
          } else if (itemIndex && cart.items[parseInt(itemIndex) - 1]) {
            const tempItem = cart.items[parseInt(itemIndex) - 1];
            qty = tempItem.quantity ? tempItem.quantity.toString() : '1';
          }
          
          if (quantityInput) {
            quantityInput.style.display = 'none';
            quantityInput.disabled = true;
            quantityInput.setAttribute('readonly', 'readonly');
            quantityInput.value = qty;
          }
          
          quantityButtons.forEach(button => {
            button.style.display = 'none';
            button.disabled = true;
            button.setAttribute('aria-hidden', 'true');
          });
          
          // Show quantity as text instead
          if (quantityWrapper) {
            let quantityDisplay = quantityWrapper.querySelector('.quantity-display');
            if (!quantityDisplay) {
              quantityDisplay = document.createElement('span');
              quantityDisplay.className = 'quantity-display';
              quantityDisplay.style.margin = '0 0.5rem';
              quantityDisplay.style.fontWeight = '500';
              quantityWrapper.appendChild(quantityDisplay);
            }
            quantityDisplay.textContent = qty;
          }
        }
      });
    } catch (error) {
      console.error('Error hiding quantity for cloak-color items:', error);
    }
  }
  
  // Helper function to refresh the cart UI with new cart data
  async function refreshCartUI(cartData) {
    if (!cartData) return;
    
    // Get the cart drawer/notification element
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    
    if (cartDrawer && cartDrawer.renderContents) {
      // Get sections to render
      const sectionsToRender = cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender() : [];
      
      // Build sections URL - get section IDs
      const sectionIds = sectionsToRender.map(s => s.section || s.id).filter(Boolean);
      if (sectionIds.length === 0) {
        // Default sections if none specified
        sectionIds.push('cart-drawer', 'cart-icon-bubble');
      }
      
      // Fetch cart sections
      const sectionsUrl = `${window.Shopify?.routes?.root || '/'}cart?${sectionIds.map(id => `section_id=${id}`).join('&')}`;
      
      try {
        const sectionsResponse = await fetch(sectionsUrl);
        if (sectionsResponse.ok) {
          const sectionsText = await sectionsResponse.text();
          const parser = new DOMParser();
          const sectionsDoc = parser.parseFromString(sectionsText, 'text/html');
          
          // Build parsedState with sections
          const parsedState = {
            ...cartData,
            sections: {}
          };
          
          // Extract each section
          sectionIds.forEach(sectionId => {
            const sectionElement = sectionsDoc.querySelector(`#shopify-section-${sectionId}`) ||
                                  sectionsDoc.querySelector(`[id*="${sectionId}"]`) ||
                                  sectionsDoc.querySelector(`.shopify-section[id*="${sectionId}"]`);
            
            if (sectionElement) {
              parsedState.sections[sectionId] = sectionElement.outerHTML;
            }
          });
          
          // If we have sections, render the cart drawer
          if (Object.keys(parsedState.sections).length > 0) {
            cartDrawer.renderContents(parsedState);
            
            // Reorder cart items: main product first, then color upgrade
            setTimeout(() => {
              if (typeof reorderCartItems === 'function') {
                reorderCartItems();
              }
            }, 100);
          }
        }
      } catch (error) {
        console.error('Error fetching cart sections:', error);
      }
    }
    
    // Publish cart update event
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'color-upgrade',
        cartData: cartData
      });
    }
    
    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
  }
  window.refreshCartUI = refreshCartUI;

  // Remove a cart item by its key
  async function removeCartItem(itemKey) {
    if (!itemKey) {
      console.error('[Cloak Color] removeCartItem: No item key provided');
      return;
    }
    
    try {
      console.log('[Cloak Color] removeCartItem: Removing item', itemKey);
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });
      
      if (response.ok) {
        console.log('[Cloak Color] removeCartItem: Successfully removed item', itemKey);
        // Clean up metadata from localStorage
        removeColorShellMetadata(itemKey);
        const cartData = await response.json();
        await refreshCartUI(cartData);
      }
    } catch (error) {
      console.error('Error removing cart item:', error);
    }
  }
  
  // Reorder cart items so main product appears first, then color upgrade
  function reorderCartItems() {
    // Try multiple selectors for cart page and cart drawer
    const cartItemsContainer = document.querySelector('#CartDrawer-CartItems tbody, #main-cart-items tbody, .cart-items tbody, table.cart-items tbody');
    if (!cartItemsContainer) return;
    
    const cartItems = Array.from(cartItemsContainer.querySelectorAll('tr.cart-item, .cart-item'));
    if (cartItems.length < 2) return;
    
    // Find color upgrade item - check by SKU (102010, 102011) or product title
    const colorUpgradeItem = cartItems.find(item => {
      const itemText = item.textContent || '';
      const itemLink = item.querySelector('a[href*="/products/"]');
      
      // Check by SKU (color products have specific SKUs)
      const hasColorSku = itemText.includes('SKU: 102010') || 
                          itemText.includes('SKU: 102011') ||
                          itemText.includes('SKU: 102017') ||
                          itemText.includes('102010') ||
                          itemText.includes('102011') ||
                          itemText.includes('102017');
      
      // Check by product title
      let isColorProduct = false;
      if (itemLink) {
        const title = itemLink.textContent || '';
        isColorProduct = title.toLowerCase().includes('arctic white') ||
                         title.toLowerCase().includes('safety yellow') ||
                         title.toLowerCase().includes('recon haze') ||
                         title.toLowerCase().includes('cloak-arctic') ||
                         title.toLowerCase().includes('cloak-safety') ||
                         title.toLowerCase().includes('cloak-recon');
      }
      
      // Check for _upgrade property (may be hidden but could be in data attributes)
      const hasUpgradeProperty = itemText.includes('_upgrade') || 
                                  itemText.includes('Shell Color Upgrade');
      
      return hasColorSku || isColorProduct || hasUpgradeProperty;
    });
    
    // Find main product item (the one that's NOT the color upgrade)
    const mainProductItem = cartItems.find(item => {
      // Skip if this is the color upgrade item
      if (item === colorUpgradeItem) return false;
      
      // Check if this item has the current product ID
      const itemId = item.getAttribute('data-foxkit-product-id') || 
                     item.getAttribute('data-product-id') ||
                     item.getAttribute('id')?.match(/CartItem-(\d+)/)?.[1];
      
      // Also check by product title - main product should be "Test Cloak" or similar
      const itemLink = item.querySelector('a[href*="/products/"]');
      if (itemLink) {
        const title = itemLink.textContent || '';
        // Main product typically has "Cloak" in the name but not color names
        const isMainProduct = title.toLowerCase().includes('cloak') && 
                              !title.toLowerCase().includes('arctic') &&
                              !title.toLowerCase().includes('safety yellow');
        
        if (isMainProduct) return true;
      }
      
      // If we have a color upgrade item, the other item is likely the main product
      if (colorUpgradeItem) {
        return true;
      }
      
      return false;
    });
    
    // If we found both items, reorder them
    if (mainProductItem && colorUpgradeItem) {
      const mainIndex = cartItems.indexOf(mainProductItem);
      const colorIndex = cartItems.indexOf(colorUpgradeItem);
      
      // If color is before main product, reorder
      if (colorIndex < mainIndex) {
        // Get all other items (not main or color)
        const otherItems = cartItems.filter(item => 
          item !== mainProductItem && item !== colorUpgradeItem
        );
        
        // Remove main and color items
        mainProductItem.remove();
        colorUpgradeItem.remove();
        
        // Re-insert in correct order: main first, then color, then other items
        if (otherItems.length > 0 && otherItems[0].parentNode) {
          // Insert main product before first other item
          cartItemsContainer.insertBefore(mainProductItem, otherItems[0]);
          // Insert color upgrade after main product
          cartItemsContainer.insertBefore(colorUpgradeItem, mainProductItem.nextSibling);
        } else {
          // No other items, just insert main then color at the top
          cartItemsContainer.insertBefore(mainProductItem, cartItemsContainer.firstChild);
          cartItemsContainer.insertBefore(colorUpgradeItem, mainProductItem.nextSibling);
        }
      }
    }
  }
  
  // Fix broken images in collection grid by replacing with color shell images
  function fixCollectionGridImages() {
    // Only run on collection pages
    const productGrid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (!productGrid) return;
    
    // Find all product cards for cloak-color products
    const productCards = productGrid.querySelectorAll('.card-wrapper[data-product-id]');
    
    productCards.forEach(async (card) => {
      const productId = card.getAttribute('data-product-id');
      if (!productId || !currentProductId || productId.toString() !== currentProductId.toString()) return;
      
      // Check if this is the cloak-color product
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;
      
      const productHandle = productLink.getAttribute('href')?.match(/\/products\/([^\/\?#]+)/)?.[1];
      if (!productHandle || !productHandle.includes('cloak')) return;
      
      // Find the product image
      const productImage = card.querySelector('.card__media img, .media img');
      if (!productImage) return;
      
      // Check if image is broken or missing
      const checkImage = () => {
        const imgSrc = productImage.src || productImage.getAttribute('src');
        // Check if image source is invalid, placeholder, or broken
        const isPlaceholder = imgSrc && (
          imgSrc.includes('placeholder') || 
          imgSrc.includes('no-image') ||
          imgSrc.includes('missing') ||
          imgSrc.includes('broken')
        );
        
        // Check if image failed to load
        const isBroken = !productImage.complete || 
                        productImage.naturalWidth === 0 || 
                        productImage.naturalHeight === 0 ||
                        isPlaceholder;
        
        if (isBroken) {
          // Image is broken, try to replace with color shell image
          replaceWithColorShellImage(productImage, card);
        }
      };
      
      // Check immediately and after load
      if (productImage.complete) {
        checkImage();
      } else {
        productImage.addEventListener('load', checkImage);
        productImage.addEventListener('error', () => {
          replaceWithColorShellImage(productImage, card);
        });
      }
      
      // Also check after a delay in case image loads but is still broken
      setTimeout(checkImage, 2000);
    });
  }
  
  // Replace broken image with color shell image
  async function replaceWithColorShellImage(brokenImage, card) {
    // Skip if already replaced
    if (brokenImage.hasAttribute('data-replaced-with-color-shell')) return;
    
    // Try to get a color shell image (prefer arctic white first, then others)
    const colorHandles = ['cloak-arctic-white', 'cloak-safety-yellow', 'cloak-neon-pink', 'cloak-safety-orange', 'cloak-purple', 'cloak-police-blue', 'cloak-army-green', 'cloak-black-carbon-fiber', 'cloak-dark-grey', 'cloak-recon-haze-topo'];
    
    for (const handle of colorHandles) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (response.ok) {
          const product = await response.json();
          if (product.featured_image) {
            let imageUrl = product.featured_image;
            // Convert to proper Shopify image URL format
            if (typeof imageUrl === 'string') {
              // If it's already a full URL, use it; otherwise construct it
              if (!imageUrl.startsWith('http')) {
                imageUrl = `https://cdn.shopify.com${imageUrl}`;
              }
              // Ensure we get a good size
              if (!imageUrl.includes('_533x') && !imageUrl.includes('_master')) {
                imageUrl = imageUrl.replace(/\?v=\d+/, '') + '?width=533';
              }
            } else if (imageUrl.src) {
              imageUrl = imageUrl.src;
            }
            
            // Update the broken image
            brokenImage.src = imageUrl;
            brokenImage.srcset = '';
            // Also update any srcset attributes
            if (brokenImage.hasAttribute('srcset')) {
              brokenImage.removeAttribute('srcset');
            }
            // Mark as replaced to prevent multiple replacements
            brokenImage.setAttribute('data-replaced-with-color-shell', 'true');
            return; // Successfully replaced
          }
        }
      } catch (error) {
        // Continue to next color
        continue;
      }
    }
  }
  
  // Run image fix when collection grid loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(fixCollectionGridImages, 1000);
      setTimeout(fixCollectionGridImages, 2000);
    });
  } else {
    setTimeout(fixCollectionGridImages, 1000);
    setTimeout(fixCollectionGridImages, 2000);
  }
  
  // Also run reordering when cart page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(reorderCartItems, 500);
      setTimeout(reorderCartItems, 1000);
    });
  } else {
    setTimeout(reorderCartItems, 500);
    setTimeout(reorderCartItems, 1000);
  }
  
  let interceptAddToCartRegistered = false;
  function interceptAddToCart() {
    // Guard: only register the subscriber once even if called multiple times
    if (interceptAddToCartRegistered) return;
    interceptAddToCartRegistered = true;

    // Listen for cart update events and add color product if selected
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, async function(event) {
        // Skip if this event was from our color-upgrade to prevent loops
        if (event.source === 'color-upgrade') {
          return;
        }

        // Only add if the event is from product-form (main product was added)
        console.log('[Cloak Color] interceptAddToCart: event.source =', event.source);
        if (event.source !== 'product-form') {
          console.log('[Cloak Color] interceptAddToCart: Not a product-form event, skipping');
          return;
        }

        // Block the monitor IMMEDIATELY (before any async work) to prevent it from
        // adding a black shell during the window between main product landing and color shell being added
        if (!window.addingColorUpgrades) window.addingColorUpgrades = new Set();
        const interceptToken = `intercept-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        window.addingColorUpgrades.add(interceptToken);
        console.log('[Cloak Color] interceptAddToCart: Monitor blocked immediately with token:', interceptToken);

        const releaseInterceptToken = () => {
          if (window.addingColorUpgrades) window.addingColorUpgrades.delete(interceptToken);
          console.log('[Cloak Color] interceptAddToCart: Released monitor block:', interceptToken);
        };

        // Only add if a color product is selected and main product was just added
        if (!window.selectedColorProduct) {
          console.log('[Cloak Color] interceptAddToCart: No color product selected, checking for default (black)...');
          // Try to find the black product as default
          // First try window.cloakColorProducts, then try to find it from the DOM
          let colorProducts = window.cloakColorProducts || [];
          if (colorProducts.length === 0) {
            // Try to get from liquidProducts if available
            const productsDataElement = document.getElementById('cloak-color-products-data');
            if (productsDataElement) {
              try {
                const products = JSON.parse(productsDataElement.textContent);
                if (products && products.length > 0) {
                  colorProducts = products;
                  window.cloakColorProducts = colorProducts;
                  console.log('[Cloak Color] interceptAddToCart: Loaded products from DOM:', colorProducts.length);
                }
              } catch (e) {
                console.error('[Cloak Color] interceptAddToCart: Error parsing product data:', e);
              }
            }
            
            // Fallback: try to load black product directly
            if (colorProducts.length === 0) {
              try {
                const neededHandle = getBlackProductHandleForCart(event.cartData.items);
                const response = await fetch(`/products/${neededHandle}.js`);
                if (response.ok) {
                  const blackProduct = await response.json();
                  if (blackProduct && blackProduct.id) {
                    colorProducts = [blackProduct];
                    window.cloakColorProducts = colorProducts;
                    console.log('[Cloak Color] interceptAddToCart: Loaded black product directly:', neededHandle);
                  }
                }
              } catch (e) {
                console.error('[Cloak Color] interceptAddToCart: Error loading black product:', e);
              }
            }
          }
          
          const neededHandle = getBlackProductHandleForCart(event.cartData.items);
          const blackProduct = colorProducts.find(p => {
            const handle = (p.handle || '').toLowerCase();
            return handle === neededHandle;
          });
          if (blackProduct) {
            console.log('[Cloak Color] interceptAddToCart: Using black as default color');
            window.selectedColorProduct = blackProduct;
          } else {
            console.log('[Cloak Color] interceptAddToCart: No color product selected and no black product found');
            console.log('[Cloak Color] interceptAddToCart: Available color products:', colorProducts.map(p => p.handle || p.title));
            releaseInterceptToken();
            return;
          }
        }
        
        console.log('[Cloak Color] interceptAddToCart: Main product added, will add color shell', {
          productVariantId: event.productVariantId,
          selectedColorProduct: window.selectedColorProduct?.handle || window.selectedColorProduct?.title,
          cartData: event.cartData
        });

        // Track this addition with a unique ID to prevent duplicate processing
        // Use variant ID + timestamp + random to ensure uniqueness
        const additionId = `${event.productVariantId}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        if (!window.processedAdditions) {
          window.processedAdditions = new Set();
        }

        // Check if we've already processed this exact addition
        // This prevents the same event from being processed multiple times
        if (window.processedAdditions.has(additionId)) {
          console.log('[Cloak Color] interceptAddToCart: Already processed this addition, skipping');
          releaseInterceptToken();
          return;
        }

        // Mark this addition as processed (but allow it to proceed)
        // We'll remove it after a delay to allow the same variant to be added again later
        window.processedAdditions.add(additionId);
        setTimeout(() => {
          window.processedAdditions.delete(additionId);
        }, 5000); // Clear after 5 seconds

        // Store the selected color product for this specific addition
        // This ensures we use the correct color even if the user changes selection between additions
        let selectedColorForThisAddition = window.selectedColorProduct;
        
        // Dynamically correct black handle for this addition based on the added product SKU
        if (selectedColorForThisAddition && (selectedColorForThisAddition.handle === 'cloak-black' || selectedColorForThisAddition.handle === 'black-xl')) {
          const neededHandle = getBlackProductHandleForCart(event.cartData);
          if (neededHandle !== selectedColorForThisAddition.handle) {
            console.log('[Cloak Color] interceptAddToCart: Selected color is black, but SKU calls for handle:', neededHandle);
            let colorProducts = window.cloakColorProducts || [];
            let correctBlackProduct = colorProducts.find(p => (p.handle || '').toLowerCase() === neededHandle);
            if (correctBlackProduct) {
              selectedColorForThisAddition = correctBlackProduct;
            } else {
              try {
                const response = await fetch(`/products/${neededHandle}.js`);
                if (response.ok) {
                  correctBlackProduct = await response.json();
                  if (correctBlackProduct && correctBlackProduct.id) {
                    if (!window.cloakColorProducts) window.cloakColorProducts = [];
                    window.cloakColorProducts.push(correctBlackProduct);
                    selectedColorForThisAddition = correctBlackProduct;
                    console.log('[Cloak Color] interceptAddToCart: Loaded correct black product directly:', neededHandle);
                  }
                }
              } catch (e) {
                console.error('[Cloak Color] interceptAddToCart: Error loading correct black product:', e);
              }
            }
          }
        }
        
        console.log('[Cloak Color] interceptAddToCart: Storing color for this addition:', selectedColorForThisAddition?.handle || selectedColorForThisAddition?.title);
        
        if (!selectedColorForThisAddition) {
          console.error('[Cloak Color] interceptAddToCart: No color product selected, cannot add shell');
          releaseInterceptToken();
          return;
        }
        
        // Add a delay to ensure the main product is fully added to cart before we check
        // This is especially important when adding multiple products quickly
        setTimeout(async () => {
          // Use cartData from event if available (more reliable), otherwise fetch
          const findMainProductAndAddShell = async (cartData, selectedColor) => {
            console.log('[Cloak Color] interceptAddToCart: findMainProductAndAddShell called with selectedColor:', selectedColor?.handle || selectedColor?.title);
          // Always fetch fresh cart data to ensure we have the latest state
          // This is critical when adding multiple products - we need to see all existing items
          console.log('[Cloak Color] interceptAddToCart: Fetching fresh cart data...');
          try {
            const cartResponse = await fetch('/cart.js?t=' + Date.now());
            if (cartResponse.ok) {
              cartData = await cartResponse.json();
              console.log('[Cloak Color] interceptAddToCart: Fetched fresh cart with', cartData.items?.length || 0, 'items');
            } else {
              console.error('[Cloak Color] interceptAddToCart: Failed to fetch cart');
              return;
            }
          } catch (error) {
            console.error('[Cloak Color] interceptAddToCart: Error fetching cart:', error);
            return;
          }
          
          // Get the variant ID that was just added from the event
          const addedVariantId = event.productVariantId || cartData?.variant_id;
          console.log('[Cloak Color] interceptAddToCart: Looking for variant', addedVariantId, 'in cart with', cartData?.items?.length || 0, 'items');
          
          // Find the specific variant that was just added (not just any product with same product_id)
          // When the same product is added multiple times, we need to find the NEWEST one
          let mostRecentMainProduct = null;
          
          if (addedVariantId && cartData.items) {
            // Find ALL items with this variant ID (excluding color shells)
            const itemsWithThisVariant = cartData.items.filter(item => {
              const matchesVariant = item.variant_id && item.variant_id.toString() === addedVariantId.toString();
              const isMainProduct = isEligibleMainProduct(item);
              console.log('[Cloak Color] interceptAddToCart: Checking item', {
                key: item.key,
                variant_id: item.variant_id,
                variant_id_type: typeof item.variant_id,
                addedVariantId: addedVariantId,
                addedVariantId_type: typeof addedVariantId,
                matchesVariant: matchesVariant,
                isMainProduct: isMainProduct,
                isColorShell: isColorShellItem(item),
                title: item.title
              });
              return matchesVariant && isMainProduct;
            });
            
            console.log('[Cloak Color] interceptAddToCart: Found', itemsWithThisVariant.length, 'main product items with variant', addedVariantId);
            console.log('[Cloak Color] interceptAddToCart: Items with this variant:', itemsWithThisVariant.map(item => ({
              key: item.key,
              variant_id: item.variant_id,
              quantity: item.quantity,
              title: item.title
            })));
            
            // Also log ALL cart items for debugging
            console.log('[Cloak Color] interceptAddToCart: ALL cart items:', cartData.items.map(item => ({
              key: item.key,
              variant_id: item.variant_id,
              product_id: item.product_id,
              quantity: item.quantity,
              title: item.title,
              isColorShell: isColorShellItem(item)
            })));
            
            if (itemsWithThisVariant.length > 0) {
              // Check if the quantity increased - if so, this might be a new addition of the same variant
              // We need to check if there are multiple line items OR if quantity increased
              const totalQuantity = itemsWithThisVariant.reduce((sum, item) => sum + (item.quantity || 1), 0);
              console.log('[Cloak Color] interceptAddToCart: Total quantity of this variant:', totalQuantity);
              
              // CRITICAL: If quantity > 1, Shopify incremented instead of creating a new line item
              // We need to split it into separate line items by adding a unique property
              // But first, let's check if we can find the most recent item
              // Always use the FIRST item (most recently added) - this is the one we just added
              // Each product instance can have its own color shell
              mostRecentMainProduct = itemsWithThisVariant[0];
              
              // If the quantity is > 1, we need to handle this differently
              // The issue is that Shopify combined multiple additions into one line item
              // We should check if this item already has a shell - if it does, and quantity > 1,
              // we need to split it and add a shell for the new quantity
              if (mostRecentMainProduct.quantity > 1) {
                console.log('[Cloak Color] interceptAddToCart: WARNING - Product has quantity > 1, Shopify incremented instead of creating separate line item');
                console.log('[Cloak Color] interceptAddToCart: This means multiple products were combined. We need to check if a shell exists for this item.');
              }
              
              console.log('[Cloak Color] interceptAddToCart: Using most recent product (last in array):', mostRecentMainProduct.key, mostRecentMainProduct.title, 'quantity:', mostRecentMainProduct.quantity, 'Total items with this variant:', itemsWithThisVariant.length);
              
              // Since we prevent quantity increases for cloak-color products, each addition should be a separate line item
              // However, Shopify might reuse the same key when the same variant is added multiple times
              // We need a different approach: always add a shell for each product-form event, but use
              // the addition tracking to prevent duplicate processing
              
              // Don't check for shells here - we'll do it in the unified check below
              // Just keep mostRecentMainProduct set so we can check and add the shell later
              console.log('[Cloak Color] interceptAddToCart: Found product instance:', {
                key: mostRecentMainProduct.key,
                variant_id: mostRecentMainProduct.variant_id,
                product_id: mostRecentMainProduct.product_id,
                title: mostRecentMainProduct.title,
                quantity: mostRecentMainProduct.quantity
              });
            }
          }
          
          // Fallback: if variant ID not available, find most recently added item with matching product_id
          // This handles cases where the variant ID isn't in the event, or when adding different variants of the same product
          if (!mostRecentMainProduct && cartData.items) {
            console.log('[Cloak Color] interceptAddToCart: Variant-based search failed, trying fallback with product_id', currentProductId);
            const mainProductItems = cartData.items.filter(item => {
                const matchesProduct = item.product_id && item.product_id.toString() === currentProductId.toString();
                const isMainProduct = isEligibleMainProduct(item);
                return matchesProduct && isMainProduct;
              });
            
            console.log('[Cloak Color] interceptAddToCart: Fallback - found', mainProductItems.length, 'main product items with product_id', currentProductId);
            console.log('[Cloak Color] interceptAddToCart: Fallback - items:', mainProductItems.map(item => ({
              key: item.key,
              variant_id: item.variant_id,
              quantity: item.quantity,
              title: item.title
            })));
            
            if (mainProductItems.length > 0) {
              // Always use the FIRST item (most recently added) - this is the one we just added
              mostRecentMainProduct = mainProductItems[0];
              console.log('[Cloak Color] interceptAddToCart: Fallback - using most recent product (first in array):', mostRecentMainProduct.key, mostRecentMainProduct.title, 'quantity:', mostRecentMainProduct.quantity, 'Total items with this product_id:', mainProductItems.length);
              
              // Don't check for shells here - we'll do it in the unified check below
              // Just keep mostRecentMainProduct set so we can check and add the shell later
              console.log('[Cloak Color] interceptAddToCart: Fallback - Found product instance, will check for shell in unified check');
            }
          }
          
          if (mostRecentMainProduct) {
            console.log('[Cloak Color] interceptAddToCart: Found main product:', {
              key: mostRecentMainProduct.key,
              variant_id: mostRecentMainProduct.variant_id,
              title: mostRecentMainProduct.title,
              quantity: mostRecentMainProduct.quantity
            });

            // Check if this product has _no_shell_addon property (set when black_only is true)
            const hasNoShellAddonProperty = mostRecentMainProduct.properties && mostRecentMainProduct.properties._no_shell_addon === 'true';
            if (hasNoShellAddonProperty) {
              console.log('[Cloak Color] interceptAddToCart: Skipping shell addon - product has _no_shell_addon flag');
              return;
            }
            
            // Check if THIS specific main product instance already has a shell
            // Rule: One shell per main product line item
            // Each product can have its own shell, regardless of other products
            // Use stable key format (product_id:variant_id) to match shells even if cart item key changes
            const stableMainProductKey = `${mostRecentMainProduct.product_id}:${mostRecentMainProduct.variant_id}`;
            const cartItemKey = mostRecentMainProduct.key; // Also check old format for backwards compatibility

            const shellsForThisProduct = cartData.items.filter(colorShell => {
              if (!isColorShellItem(colorShell)) return false;
              // Get mainProductKey from localStorage
              let mainProductKey = getColorShellMainProductKey(colorShell.key);
              // Match by stable key (product_id:variant_id) or by old cart item key (backwards compatibility)
              const matches = mainProductKey && (mainProductKey === stableMainProductKey || mainProductKey === cartItemKey);
              if (matches) {
                console.log('[Cloak Color] interceptAddToCart: Found shell for this product:', colorShell.key, 'linked to', mainProductKey);
              }
              return matches;
            });
            
            console.log('[Cloak Color] interceptAddToCart: Checking product instance:', {
              key: mostRecentMainProduct.key,
              variant_id: mostRecentMainProduct.variant_id,
              product_id: mostRecentMainProduct.product_id,
              title: mostRecentMainProduct.title
            });
            console.log('[Cloak Color] interceptAddToCart: Shells linked to this specific product instance:', shellsForThisProduct.length);
            console.log('[Cloak Color] interceptAddToCart: All shells in cart:', cartData.items.filter(isColorShellItem).map(item => {
              const mainProductKey = getColorShellMainProductKey(item.key);
              return {
                key: item.key,
                title: item.title,
                main_product_key: mainProductKey,
                matches: mainProductKey === mostRecentMainProduct.key
              };
            }));
            
            // Always add a shell on each add-to-cart event
            // This ensures each item added gets its own shell
            // The cleanup function will handle removing extras if quantity doesn't support multiple shells
            // This is the correct approach because we can't reliably detect the intent from quantity alone
            // (Shopify combines items into quantity > 1, so we won't know if user intended to add 2 separate items)
            const shouldAddShell = true; // Always add shell for each add event

            if (shouldAddShell) {
              console.log('[Cloak Color] interceptAddToCart: Will add shell on add-to-cart event (existing shells:', shellsForThisProduct.length, ')');
              console.log('[Cloak Color] interceptAddToCart: Product details:', {
                key: mostRecentMainProduct.key,
                variant_id: mostRecentMainProduct.variant_id,
                product_id: mostRecentMainProduct.product_id,
                quantity: mostRecentMainProduct.quantity,
                title: mostRecentMainProduct.title,
                existingShells: shellsForThisProduct.length
              });
              console.log('[Cloak Color] interceptAddToCart: Selected color product:', (selectedColor || window.selectedColorProduct)?.handle || (selectedColor || window.selectedColorProduct)?.title);
              
              // Store the main product identifier as unique line item key to prevent Shopify merging shells
              // of different holsters with same variant ID (e.g. different gun models)
              window.latestMainProductId = mostRecentMainProduct.product_id;
              window.latestMainProductVariantId = mostRecentMainProduct.variant_id;
              window.latestMainProductKey = mostRecentMainProduct.key;

              console.log('[Cloak Color] interceptAddToCart: Stored latestMainProductKey =', window.latestMainProductKey, '(unique key)');
              
              // Use the color that was selected when this product was added (passed as parameter)
              const colorToAdd = selectedColor || window.selectedColorProduct;
              if (!colorToAdd) {
                console.error('[Cloak Color] interceptAddToCart: No color product selected!', {
                  selectedColor: selectedColor?.handle || selectedColor?.id,
                  windowSelectedColor: window.selectedColorProduct?.handle || window.selectedColorProduct?.id
                });
                return;
              }
              console.log('[Cloak Color] interceptAddToCart: About to call addColorProductToCart with:', colorToAdd?.handle || colorToAdd?.title || colorToAdd?.id);

              // Add color product - it will link to this main product
              try {
                await addColorProductToCart(colorToAdd);
                console.log('[Cloak Color] interceptAddToCart: addColorProductToCart completed');
              } catch (error) {
                console.error('[Cloak Color] interceptAddToCart: Error calling addColorProductToCart:', error);
              }
            } else {
              console.log('[Cloak Color] interceptAddToCart: This product instance already has', shellsForThisProduct.length, 'shell(s) for quantity', mostRecentMainProduct.quantity, ', skipping');
              console.log('[Cloak Color] interceptAddToCart: Existing shell(s):', shellsForThisProduct.map(s => ({
                key: s.key,
                title: s.title
              })));
              console.log('[Cloak Color] interceptAddToCart: Product that already has shell:', {
                key: mostRecentMainProduct.key,
                variant_id: mostRecentMainProduct.variant_id,
                product_id: mostRecentMainProduct.product_id,
                quantity: mostRecentMainProduct.quantity,
                title: mostRecentMainProduct.title
              });
            }
          } else {
            console.log('[Cloak Color] interceptAddToCart: Could not find main product in cart, trying last-resort fallback...');
            console.log('[Cloak Color] interceptAddToCart: Cart items:', cartData.items?.map(item => ({
              key: item.key,
              variant_id: item.variant_id,
              product_id: item.product_id,
              title: item.title,
              sku: item.sku,
              handle: item.handle,
              isColorShell: isColorShellItem(item),
              properties: item.properties
            })));
            
            // Last resort: use the last non-shell item in the cart
            // This handles cases where the variant/product_id matching fails
            const nonShellItems = cartData.items?.filter(item => isEligibleMainProduct(item)) || [];
            console.log('[Cloak Color] interceptAddToCart: Non-shell items found:', nonShellItems.length);
            if (nonShellItems.length > 0) {
              mostRecentMainProduct = nonShellItems[0];
              console.log('[Cloak Color] interceptAddToCart: Last-resort fallback - using first non-shell item:', {
                key: mostRecentMainProduct.key,
                variant_id: mostRecentMainProduct.variant_id,
                product_id: mostRecentMainProduct.product_id,
                title: mostRecentMainProduct.title
              });
              
              // Check if this product has _no_shell_addon property (set when black_only is true)
              const hasNoShellAddonProperty = mostRecentMainProduct.properties && mostRecentMainProduct.properties._no_shell_addon === 'true';
              if (hasNoShellAddonProperty) {
                console.log('[Cloak Color] interceptAddToCart: Skipping shell addon (fallback path) - product has _no_shell_addon flag');
                return;
              }
              
              // Now proceed with adding the shell using the same logic as above
              // Check if THIS specific main product instance already has a shell
              // Use stable key format (product_id:variant_id) to match shells even if cart item key changes
              const stableMainProductKey = `${mostRecentMainProduct.product_id}:${mostRecentMainProduct.variant_id}`;
              const cartItemKey = mostRecentMainProduct.key; // Also check old format for backwards compatibility

              const shellsForThisProduct = cartData.items.filter(colorShell => {
                if (!isColorShellItem(colorShell)) return false;
                // Get mainProductKey from localStorage
                const mainProductKey = getColorShellMainProductKey(colorShell.key);
                // Match by stable key (product_id:variant_id) or by old cart item key (backwards compatibility)
                return mainProductKey && (mainProductKey === stableMainProductKey || mainProductKey === cartItemKey);
              });

              // Always add a shell on each add-to-cart event (fallback path)
              // This ensures each item added gets its own shell with the selected color
              const shouldAddShell = true;

              if (shouldAddShell) {
                // Always add shell on add event (fallback path)
                console.log('[Cloak Color] interceptAddToCart: Adding shell via fallback path (existing shells:', shellsForThisProduct.length, ')');
                const colorToAdd = selectedColor || window.selectedColorProduct;
                if (colorToAdd) {
                  // Store unique key so it gets used in addColorProductToCart (fallback)
                  window.latestMainProductId = mostRecentMainProduct.product_id;
                  window.latestMainProductVariantId = mostRecentMainProduct.variant_id;
                  window.latestMainProductKey = mostRecentMainProduct.key;
                  console.log('[Cloak Color] interceptAddToCart: Stored unique main product key (fallback):', window.latestMainProductKey);
                  await addColorProductToCart(colorToAdd);
                } else {
                  console.error('[Cloak Color] interceptAddToCart: No color product selected for fallback');
                }
              } else {
                console.log('[Cloak Color] interceptAddToCart: Product already has shell (via fallback), skipping');
              }
            } else {
              console.log('[Cloak Color] interceptAddToCart: No non-shell items found in cart, cannot add color shell');
              return;
            }
          }
        };
        
          // Call the function with the event's cartData and the selected color for this addition
          console.log('[Cloak Color] interceptAddToCart: About to call findMainProductAndAddShell');
          findMainProductAndAddShell(event.cartData, selectedColorForThisAddition)
            .catch(error => {
              console.error('[Cloak Color] interceptAddToCart: Error in findMainProductAndAddShell:', error);
            })
            .finally(() => {
              releaseInterceptToken();
            });
        }, 50); // Minimal delay for fastest shell addition

        // Safety fallback: always release token after 10 seconds even if something goes wrong
        setTimeout(releaseInterceptToken, 10000);
      });
    }
  }
  
  let initColorPriceUpdatesRegistered = false;
  function initColorPriceUpdates() {
    // Intercept add to cart
    interceptAddToCart();

    // Guard: only register the cleanup subscriber once
    if (initColorPriceUpdatesRegistered) return;
    initColorPriceUpdatesRegistered = true;

    // Listen for cart updates to remove color shells when main products are removed
    // Also prevents color shells from existing without main products
    // Also handles quantity increases for color shell upgrades
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, async function(event) {
        console.log('[Cloak Color] Cart update event received:', event.source, event);
        
        // Skip if this event was from our color-upgrade to prevent loops
        // BUT still allow cleanup to run - it's critical for enforcing rules
        if (event.source === 'color-upgrade' || event.source === 'color-quantity-split') {
          console.log('[Cloak Color] Cart update: Skipping (source is', event.source + ')');
          return;
        }
        
        // Allow color-cleanup events to still run cleanup (but skip other handlers)
        const isCleanupEvent = event.source === 'color-cleanup';
        
        // Skip cleanup entirely if this is a product-form event (main product being added)
        // We don't want to interfere with the add-to-cart process
        // BUT allow interceptAddToCart to run (it's in a separate subscription)
        if (event.source === 'product-form') {
          console.log('[Cloak Color] Cart update: Skipping cleanup (product-form event) - allowing interceptAddToCart to handle shell addition');
          // Don't return here - let the cleanup at the bottom run, but with a delay to allow shell to be added first
          // Actually, let's return early to prevent cleanup from interfering with the add process
          // The cleanup will run on subsequent events
          return;
        }
        
        // Skip quantity handlers for cleanup events (they'll be handled by cleanup function)
        if (!isCleanupEvent) {
          // Handle quantity increases for color shell upgrades
          if (event.cartData && event.cartData.items && event.source === 'cart-items') {
            // Commented out to allow quantity synchronization:
            // await handleColorShellQuantityUpdate(event.cartData);
          }
          
          // Enforce quantity of 1 for cloak-color items (main products)
          if (event.cartData && event.cartData.items && event.source === 'cart-items') {
            await enforceCloakColorQuantity(event.cartData);
          }
          
          // When quantity changes in cart, check if any shells were deleted and replace with black
          if (event.cartData && event.cartData.items && event.source === 'cart-items') {
            console.log('[Cloak Color] Cart update: Cart changed, checking for deleted shells...');

            // Check if a color shell was deleted
            const currentShells = event.cartData.items.filter(item => isColorShellItem(item));
            const deletedShells = previousCartItems.filter(item =>
              isColorShellItem(item) && !currentShells.find(s => s.key === item.key)
            );

            if (deletedShells.length > 0) {
              console.log('[Cloak Color] Cart update: Detected', deletedShells.length, 'deleted shell(s), adding black replacement');
              // Get black product
              const neededHandle = getBlackProductHandleForCart(event.cartData.items);
              let blackProduct = window.cloakColorProducts?.find(p => (p.handle || '').toLowerCase() === neededHandle);
              if (!blackProduct) {
                try {
                  const response = await fetch(`/products/${neededHandle}.js`);
                  if (response.ok) {
                    blackProduct = await response.json();
                  }
                } catch (e) {
                  console.warn('[Cloak Color] Could not load black product');
                }
              }

              if (blackProduct) {
                window.selectedColorProduct = blackProduct;
                await addColorProductToCart(blackProduct);
              }
            }

            // Update previous state
            previousCartItems = event.cartData.items;

            console.log('[Cloak Color] Cart update: Quantity changed via cart-items, checking for extra shells...');
            console.log('[Cloak Color] Cart update: Cart items:', event.cartData.items.map(item => ({
              key: item.key,
              title: item.title,
              quantity: item.quantity,
              variant_id: item.variant_id,
              isColorShell: isColorShellItem(item),
              product_id: item.product_id
            })));
            
            // Check if any main product quantity was reduced
            const mainProducts = event.cartData.items.filter(item => {
              if (isColorShellItem(item)) return false;
              if (currentProductId && item.product_id && item.product_id.toString() === currentProductId.toString()) {
                return true;
              }
              return false;
            });
            
            console.log('[Cloak Color] Cart update: Found', mainProducts.length, 'main product(s) in cart');
            mainProducts.forEach(mp => {
              console.log('[Cloak Color] Cart update: Main product', mp.key, 'has quantity', mp.quantity);
            });
            
            // Run cleanup multiple times to ensure it catches the change
            setTimeout(async () => {
              console.log('[Cloak Color] Cart update: Running cleanup after quantity change (300ms)...');
              await cleanupOrphanedColorShells();
            }, 300);
            setTimeout(async () => {
              console.log('[Cloak Color] Cart update: Running cleanup after quantity change (600ms)...');
              await cleanupOrphanedColorShells();
            }, 600);
            setTimeout(async () => {
              console.log('[Cloak Color] Cart update: Running cleanup after quantity change (50ms)...');
              await cleanupOrphanedColorShells();
            }, 50);
          }
          
          // Prevent quantity increments for color shell items
          if (event.cartData && event.cartData.items) {
            setTimeout(() => {
              preventColorShellQuantityIncrement();
            }, 200);
          }
          
          // Check if a color shell was just added without a main product (immediate check)
          // BUT skip this check if we're currently adding a color upgrade (to prevent interference)
          const isAddingAnyUpgrade = window.addingColorUpgrades && window.addingColorUpgrades.size > 0;
          if (!isAddingAnyUpgrade && event.cartData && event.cartData.items) {
          const cart = event.cartData;
          const colorShellItems = cart.items.filter(item => isColorShellItem(item));
          
          if (colorShellItems.length > 0) {
            // Check if there's a main product (by product_id or handle)
            const hasMainProduct = cart.items.some(item => {
              // Check by product_id first
              if (item.product_id && currentProductId && 
                  item.product_id.toString() === currentProductId.toString()) {
                return true;
              }
              // Fallback: check by handle
              const itemHandle = item.handle || '';
              return itemHandle === 'cloak-color' || itemHandle.includes('cloak-color');
            });
            
            if (!hasMainProduct) {
              console.log('[Cloak Color] Cart update: Color shells found without main product, will cleanup');
              // Color shells exist without main product - remove them
              setTimeout(async () => {
                await cleanupOrphanedColorShells();
              }, 300);
              return; // Exit early since we're handling it
            }
          }
        }
        } // End of !isCleanupEvent block
        
        // ALWAYS check for orphaned color shells and enforce rules
        // This runs for ALL events (including cleanup events) to ensure rules are always enforced
        // This is critical - color shells cannot exist without main products
        // and only one color shell per main product is allowed
        // BUT skip for product-form events - those are handled by interceptAddToCart
        // Run cleanup multiple times to ensure it catches all cases
        if (event.source !== 'product-form') {
          console.log('[Cloak Color] Cart update: Scheduling cleanup (source:', event.source + ')');
          setTimeout(async () => {
            console.log('[Cloak Color] Cart update: Running cleanup (200ms delay)...');
            await cleanupOrphanedColorShells();
            preventColorShellQuantityIncrement();
          }, 200);
          setTimeout(async () => {
            console.log('[Cloak Color] Cart update: Running cleanup (500ms delay)...');
            await cleanupOrphanedColorShells();
            preventColorShellQuantityIncrement();
          }, 500);
          setTimeout(async () => {
            console.log('[Cloak Color] Cart update: Running cleanup (50ms delay)...');
            await cleanupOrphanedColorShells();
            preventColorShellQuantityIncrement();
          }, 50);
        } else {
          console.log('[Cloak Color] Cart update: Skipping cleanup scheduling (product-form event)');
        }
      });
    }
    
    // Track cart state to detect deletions
    let previousCartItems = [];

    // Initialize previous cart state
    async function initializePreviousCartState() {
      try {
        const cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          previousCartItems = cart.items || [];
          console.log('[Cloak Color] Initialized previousCartItems with', previousCartItems.length, 'items');
        }
      } catch (e) {
        console.warn('[Cloak Color] Error initializing cart state');
      }
    }

    // Function to replace deleted color shells with black
    async function replaceDeletedShellWithBlack() {
      try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        const currentItems = cart.items || [];

        console.log('[Cloak Color] replaceDeletedShellWithBlack: Previous items:', previousCartItems.length, 'Current items:', currentItems.length);

        // Find which shell was deleted by comparing keys
        let deletedShells = previousCartItems.filter(item =>
          isColorShellItem(item) && !currentItems.find(s => s.key === item.key)
        );

        // Filter out deleted shells whose associated holsters are no longer in the cart
        deletedShells = deletedShells.filter(deletedShell => {
          const mainProductKey = getColorShellMainProductKey(deletedShell.key);
          if (!mainProductKey) return false;
          
          const holsterStillInCart = currentItems.some(cartItem => {
            const stableKey = `${cartItem.product_id}:${cartItem.variant_id}`;
            return cartItem.key === mainProductKey || stableKey === mainProductKey;
          });
          
          return holsterStillInCart;
        });

        console.log('[Cloak Color] replaceDeletedShellWithBlack: Deleted shells with active holsters:', deletedShells.length);

        if (deletedShells.length > 0) {
          // Get black product
          const neededHandle = getBlackProductHandleForCart(currentItems);
          let blackProduct = window.cloakColorProducts?.find(p => (p.handle || '').toLowerCase() === neededHandle);
          if (!blackProduct) {
            try {
              const response = await fetch(`/products/${neededHandle}.js`);
              if (response.ok) {
                blackProduct = await response.json();
                console.log('[Cloak Color] Loaded black product:', neededHandle);
              }
            } catch (e) {
              console.warn('[Cloak Color] Could not load black product');
            }
          }

          if (blackProduct) {
            console.log('[Cloak Color] replaceDeletedShellWithBlack: Adding black shell to replace deleted one');
            window.selectedColorProduct = blackProduct;
            await addColorProductToCart(blackProduct);
            console.log('[Cloak Color] replaceDeletedShellWithBlack: Black shell add initiated');
          }
        }

        // Update previous state
        previousCartItems = currentItems;
      } catch (error) {
        console.error('[Cloak Color] Error in replaceDeletedShellWithBlack:', error);
      }
    }

    // Initialize on page load
    initializePreviousCartState();

    // Track when we last attempted to add a black shell to prevent spam
    let lastBlackAddTime = 0;
    // Track whether we're currently adding a shell to prevent concurrent additions
    let isAddingBlackShell = false;

    // Periodically monitor cart and ensure main products always have a shell
    // Approach: if there are main products but no shells (and they need shells), add a black shell
    // This is simpler than tracking state transitions and handles all edge cases
    setInterval(async () => {
      // Skip if we're currently adding a shell (prevent concurrent additions)
      if (isAddingBlackShell) {
        console.log('[Cloak Color] Monitor: SKIPPED - isAddingBlackShell is true');
        return;
      }
      // Skip if we're currently adding any color upgrade (to prevent interference)
      if (window.addingColorUpgrades && window.addingColorUpgrades.size > 0) {
        console.log('[Cloak Color] Monitor: SKIPPED - addingColorUpgrades has', window.addingColorUpgrades.size, 'tokens:', Array.from(window.addingColorUpgrades));
        return;
      }
      // Skip if we're currently removing upgrades/holsters to prevent adding default shells back
      if (window.shellBeingRemoved || window.holsterBeingRemoved) {
        console.log('[Cloak Color] Monitor: SKIPPED - item removal in progress');
        return;
      }

      try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();

        // Re-check flags after the async fetch — the token may have been set during the network round-trip
        if (isAddingBlackShell) return;
        if (window.addingColorUpgrades && window.addingColorUpgrades.size > 0) {
          console.log('[Cloak Color] Monitor: SKIPPED after fetch - addingColorUpgrades has tokens (set during fetch)');
          return;
        }

        // Get current shells
        const currentShells = cart.items.filter(item => isColorShellItem(item));
        const currentShellCount = currentShells.length;

        // Get main products that need shells (not black_only)
        const mainProductsNeedingShell = cart.items.filter(item => {
          if (!isEligibleMainProduct(item)) return false;
          // Exclude items with _no_shell_addon property
          if (item.properties && item.properties._no_shell_addon === 'true') return false;
          return true;
        });

        console.log('[Cloak Color] Monitor: Shells:', currentShellCount, 'Main products needing shell:', mainProductsNeedingShell.length);

        // If there are main products that need shells but no shells in cart, add a black shell
        if (mainProductsNeedingShell.length > 0 && currentShellCount === 0) {
          const now = Date.now();
          const timeSinceLastAdd = now - lastBlackAddTime;
          console.log('[Cloak Color] Monitor: No shells but main products need them! Time since last add:', timeSinceLastAdd, 'ms');

          // Only add if we haven't tried recently (2 second cooldown)
          if (timeSinceLastAdd > 2000) {
            const mainProduct = mainProductsNeedingShell[0];
            const neededHandle = getBlackProductHandleForCartItem(mainProduct);
            console.log('[Cloak Color] Monitor: Adding black shell for main product, handle:', neededHandle);
            lastBlackAddTime = now;
            isAddingBlackShell = true;

            try {
              let blackProduct = window.cloakColorProducts?.find(p => (p.handle || '').toLowerCase() === neededHandle);
              if (!blackProduct) {
                try {
                  const response = await fetch(`/products/${neededHandle}.js`);
                  if (response.ok) {
                    blackProduct = await response.json();
                    console.log('[Cloak Color] Monitor: Loaded black product:', neededHandle);
                  }
                } catch (e) {
                  console.warn('[Cloak Color] Monitor: Could not load black product:', neededHandle);
                }
              }

              if (blackProduct) {
                window.selectedColorProduct = blackProduct;
                console.log('[Cloak Color] Monitor: Calling addColorProductToCart for black shell:', neededHandle);
                await addColorProductToCart(blackProduct);
                console.log('[Cloak Color] Monitor: Black shell add completed');
              } else {
                console.warn('[Cloak Color] Monitor: No black product available to add');
              }
            } finally {
              isAddingBlackShell = false;
            }
          } else {
            console.log('[Cloak Color] Monitor: Cooldown active, will retry in', 2000 - timeSinceLastAdd, 'ms');
          }
        }
      } catch (error) {
        console.error('[Cloak Color] Monitor error:', error);
        isAddingBlackShell = false;
      }
    }, 500);

    // Also listen for direct remove button clicks to catch deletions immediately
    document.addEventListener('click', async function(e) {
      // Check if this is a remove button click
      const removeButton = e.target.closest('cart-remove-button, [data-remove-item], .remove-item, [aria-label*="Remove"], [title*="Remove"]');
      if (removeButton) {
        console.log('[Cloak Color] Remove button clicked, checking if shell was deleted');

        // After any removal, check if a shell was deleted and replace with black
        setTimeout(async () => {
          await replaceDeletedShellWithBlack();
          await cleanupOrphanedColorShells();
          preventColorShellQuantityIncrement();
        }, 300);
      }
    });
    
    // Also listen for cart:updated custom events (fallback)
    document.addEventListener('cart:updated', async function() {
      console.log('[Cloak Color] cart:updated event received, will cleanup orphaned shells');
      setTimeout(async () => {
        await cleanupOrphanedColorShells();
        preventColorShellQuantityIncrement();
      }, 600);
    });
    
    // Intercept quantity input changes to prevent increments for color shells
    // Also trigger cleanup when quantity is reduced
    document.addEventListener('change', async function(e) {
      if (e.target.matches('.quantity__input, input[data-quantity-variant-id], input[data-cart-quantity-input], input[name*="updates"]')) {
        const input = e.target;
        const newQuantity = parseInt(input.value) || 1;
        const previousQuantity = parseInt(input.getAttribute('data-cart-quantity')) || parseInt(input.getAttribute('value')) || 1;
        
        // If quantity was reduced, run cleanup to remove extra shells
        if (newQuantity < previousQuantity) {
          console.log('[Cloak Color] Quantity reduced from', previousQuantity, 'to', newQuantity, ', running cleanup...');
          setTimeout(async () => {
            await cleanupOrphanedColorShells();
          }, 50);
        }
        
        setTimeout(() => {
          preventColorShellQuantityIncrement();
        }, 100);
      }
    });
    
    // Intercept minus button clicks to trigger cleanup when quantity is reduced
    document.addEventListener('click', async function(e) {
      const minusButton = e.target.closest('.quantity__button[name="minus"], button[name="minus"]');
      if (minusButton) {
        const quantityInput = minusButton.closest('quantity-input, .quantity')?.querySelector('.quantity__input, input[type="number"]');
        if (quantityInput) {
          const currentValue = parseInt(quantityInput.value) || 1;
          console.log('[Cloak Color] Minus button clicked, current quantity:', currentValue);
          // Run cleanup after quantity is reduced (the change event will fire after this)
          setTimeout(async () => {
            console.log('[Cloak Color] Quantity reduced via minus button, running cleanup...');
            await cleanupOrphanedColorShells();
          }, 50);
        }
      }
    });
    
    // Intercept plus button clicks to prevent increments for color shells
    document.addEventListener('click', function(e) {
      const plusButton = e.target.closest('.quantity__button[name="plus"], button[name="plus"]');
      if (plusButton) {
        const quantityInput = plusButton.closest('quantity-input, .quantity')?.querySelector('.quantity__input, input[type="number"]');
        if (quantityInput) {
          const cartItem = quantityInput.closest('.cart-item, [data-cart-item]');
          if (cartItem) {
            // Check if this is a color shell item
            const itemText = cartItem.textContent || '';
            const isColorShell = itemText.includes('SKU: 102010') || 
                                itemText.includes('SKU: 102011') || 
                                itemText.includes('SKU: 102017') || 
                                itemText.includes('SKU: 100401') ||
                                itemText.includes('Shell Color Upgrade');
            
            if (isColorShell) {
              e.preventDefault();
              e.stopPropagation();
              quantityInput.value = 1;
              return false;
            }
          }
        }
      }
    }, true); // Use capture phase to catch early
    
    // Store original images asynchronously (non-blocking)
    setTimeout(() => storeOriginalImages(), 0);
    
    // Intercept cart quantity updates
    interceptCartQuantityUpdates();
    
    // Also intercept when cart-items elements are added to DOM
    const cartObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (node.matches('cart-items') || node.matches('cart-drawer-items') || node.querySelector('cart-items, cart-drawer-items'))) {
            interceptCartQuantityUpdates();
            setTimeout(() => {
              preventColorShellQuantityIncrement();
            }, 200);
          }
        });
      });
    });
    cartObserver.observe(document.body, { childList: true, subtree: true });
    
    // Prevent quantity increments for color shells on page load
    setTimeout(() => {
      preventColorShellQuantityIncrement();
      interceptCartQuantityUpdates();
    }, 500);
    
    // Hide quantity controls on cloak-color product page
    // Run immediately and also after DOM is ready
    hideQuantityOnProductPage();
    observeQuantityControls();
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(hideQuantityOnProductPage, 100);
        setTimeout(hideQuantityOnProductPage, 500);
        setTimeout(hideQuantityOnProductPage, 1000);
        setTimeout(hideQuantityOnProductPage, 2000);
      });
    } else {
      setTimeout(hideQuantityOnProductPage, 100);
      setTimeout(hideQuantityOnProductPage, 500);
      setTimeout(hideQuantityOnProductPage, 1000);
      setTimeout(hideQuantityOnProductPage, 2000);
    }
    
    // Hide quantity controls for cloak-color items in cart
    hideQuantityForCloakColorInCart();
    
    // Re-hide quantity controls after cart updates
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event.source !== 'color-upgrade' && event.source !== 'color-cleanup' && event.source !== 'color-quantity-split') {
          setTimeout(() => {
            hideQuantityForCloakColorInCart();
          }, 100);
        }
      });
    }
    
    const colorItems = document.querySelectorAll('.cloak-color-item');
    
    colorItems.forEach((item) => {
      const colorIndex = parseInt(item.getAttribute('data-color-index'));
      const productId = item.getAttribute('data-product-id');
      const product = productId ? colorProducts.find(p => p.id.toString() === productId.toString()) : null;
      
      // Prevent navigation - make entire item clickable
      const clickable = item.querySelector('.cloak-color-clickable') || item;
      clickable.style.cursor = 'pointer';
      
      clickable.addEventListener('click', function(e) {
        // Prevent clicking on out-of-stock items
        const isOutOfStock = item.getAttribute('data-out-of-stock') === 'true' || 
                            (product && isProductOutOfStock(product));
        if (isOutOfStock) {
        e.preventDefault();
        e.stopPropagation();
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        // Always pass the product - handleColorClick will determine if it's black
        handleColorClick(colorIndex, product, false);
      });
      
      // Also prevent link navigation if links exist
      const link = item.querySelector('a');
      if (link) {
        link.addEventListener('click', function(e) {
          // Prevent clicking on out-of-stock items
          const isOutOfStock = item.getAttribute('data-out-of-stock') === 'true' || 
                              (product && isProductOutOfStock(product));
          if (isOutOfStock) {
          e.preventDefault();
          e.stopPropagation();
            return;
          }
          
          e.preventDefault();
          e.stopPropagation();
          // Always pass the product - handleColorClick will determine if it's black
          handleColorClick(colorIndex, product, false);
        });
        link.style.pointerEvents = 'none'; // Disable link navigation
      }
    });
    
    // Listen for variant option changes
    const variantInputs = document.querySelectorAll('input[name*="option"], select[name*="option"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', function() {
        const optionName = input.name.toLowerCase();
        if (optionName.includes('color') || optionName.includes('colour')) {
          const selectedValue = input.value || (input.checked ? input.value : null);
          const isBlack = selectedValue && (selectedValue.toLowerCase().includes('black'));
          
          let colorIndex = BASE_COLOR_INDEX;
          colorItems.forEach((item) => {
            const title = item.querySelector('.cloak-color-title')?.textContent.toLowerCase() || '';
            if (selectedValue && title.includes(selectedValue.toLowerCase())) {
              colorIndex = parseInt(item.getAttribute('data-color-index'));
            }
          });
          
          updatePriceForColor(colorIndex);
        }
      });
    });
    
    // Listen to theme's variant change events
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data && event.data.variant) {
          const variant = event.data.variant;
          
          // Helper function to re-apply price with fresh DOM queries
          const reapplyPrice = () => {
            if (!window.selectedColorProduct) return;
            
            // Query colorItems fresh each time to ensure we have the latest DOM
            const colorItems = document.querySelectorAll('.cloak-color-item');
            
            // Find the colorIndex for the selected color product
            let colorIndex = BASE_COLOR_INDEX;
            const selectedProductId = window.selectedColorProduct.id?.toString();
            
            if (selectedProductId) {
              colorItems.forEach((item) => {
                const productId = item.getAttribute('data-product-id');
                if (productId && productId.toString() === selectedProductId) {
                  colorIndex = parseInt(item.getAttribute('data-color-index')) || BASE_COLOR_INDEX;
                }
              });
            }
            
            updatePriceForColor(colorIndex, window.selectedColorProduct);
          };
          
          // Always re-apply price if we have a selected color product
          // This ensures the price stays correct even when other options (like optic cut) change
          if (window.selectedColorProduct) {
            // Use multiple timeouts to catch price updates that happen at different times
            // The theme's price update might happen immediately or after a delay
            setTimeout(reapplyPrice, 100);
            setTimeout(reapplyPrice, 300);
            setTimeout(reapplyPrice, 500);
            setTimeout(reapplyPrice, 800);
          } else if (variant.options) {
            // Fallback: if no selected color product, try to find from variant color option
            const colorOption = variant.options.find((opt, idx) => {
              const optionName = (variant.option_names && variant.option_names[idx]) || '';
              return optionName.toLowerCase().includes('color') || optionName.toLowerCase().includes('colour');
            });
            
            if (colorOption) {
              // Query colorItems fresh
              const colorItems = document.querySelectorAll('.cloak-color-item');
              let colorIndex = BASE_COLOR_INDEX;
              colorItems.forEach((item) => {
                const title = item.querySelector('.cloak-color-title')?.textContent.toLowerCase() || '';
                if (title.includes(colorOption.toLowerCase())) {
                  colorIndex = parseInt(item.getAttribute('data-color-index'));
                }
              });
              
              setTimeout(() => {
                updatePriceForColor(colorIndex);
              }, 300);
            }
          }
        }
      });
    }
    
    // Watch for price changes and re-apply custom price if it gets overwritten
    // This is a safety net in case the price is updated by something other than variantChange
    // Set up observer for both cloak-color and cloak-color-injection templates
    const isCloakColorTemplate = document.querySelector('[data-template-suffix="cloak-color-injection"]') || 
                                  document.querySelector('[data-template-suffix="cloak-color"]') ||
                                  document.body.classList.contains('template-product-cloak-color-injection') ||
                                  document.body.classList.contains('template-product-cloak-color');
    
    if (isCloakColorTemplate) {
      const priceContainer = getPriceContainer();
      if (priceContainer) {
        let isApplyingPrice = false;
        let lastPriceText = null;
        
        const priceObserver = new MutationObserver(() => {
          // Skip if we're currently applying the price ourselves
          if (isApplyingPrice) return;
          if (!window.selectedColorProduct) return;
          
          // Get current price text
          const priceElement = priceContainer.querySelector('.price-item--regular:not(s), .price-item--sale, .price-item--last');
          if (!priceElement) return;
          
          const currentPriceText = priceElement.textContent.trim();
          
          // Only react if price actually changed
          if (currentPriceText === lastPriceText) return;
          lastPriceText = currentPriceText;
          
          // Check if the price looks like it was reset to base (doesn't include our adjustment)
          // For non-black products, the price should be base + $7.99
          const isBlackProduct = window.selectedColorProduct && 
                                 (window.selectedColorProduct.handle === 'cloak-black' || 
                                  isBaseColor(window.selectedColorProduct));
          
          if (!isBlackProduct) {
            // For non-black products, check if price seems too low (might have been reset)
            const base = getBasePrice();
            if (base) {
              const magAdj = window.cloakMagCarrierPrice || 0;
              const priceAdj = getColorPriceAdjustment(window.selectedColorProduct.handle);
              const expectedPrice = base + priceAdj + magAdj;
              const expectedPriceText = formatPrice(expectedPrice) + ' USD';
              // If current price doesn't match expected, it was likely reset
              if (currentPriceText !== expectedPriceText && !currentPriceText.includes(formatPrice(expectedPrice))) {
                // Price was reset, re-apply
              } else {
                // Price looks correct, don't re-apply
                return;
              }
            }
          }
          
          // Debounce: wait a bit to see if more changes are coming
          clearTimeout(window.cloakColorPriceReapplyTimeout);
          window.cloakColorPriceReapplyTimeout = setTimeout(() => {
            if (!window.selectedColorProduct) return;
            
            // Query colorItems fresh
            const colorItems = document.querySelectorAll('.cloak-color-item');
            
            // Find the colorIndex for the selected color product
            let colorIndex = BASE_COLOR_INDEX;
            const selectedProductId = window.selectedColorProduct.id?.toString();
            
            if (selectedProductId) {
              colorItems.forEach((item) => {
                const productId = item.getAttribute('data-product-id');
                if (productId && productId.toString() === selectedProductId) {
                  colorIndex = parseInt(item.getAttribute('data-color-index')) || BASE_COLOR_INDEX;
                }
              });
            }
            
            // Re-apply the price
            isApplyingPrice = true;
            updatePriceForColor(colorIndex, window.selectedColorProduct);
            setTimeout(() => {
              isApplyingPrice = false;
              // Update lastPriceText after applying
              const updatedPriceElement = priceContainer.querySelector('.price-item--regular:not(s), .price-item--sale, .price-item--last');
              if (updatedPriceElement) {
                lastPriceText = updatedPriceElement.textContent.trim();
              }
            }, 100);
          }, 300);
        });
        
        // Start observing the price container
        priceObserver.observe(priceContainer, {
          childList: true,
          subtree: true,
          characterData: true
        });
        
        // Store observer so it can be cleaned up if needed
        window.cloakColorPriceObserver = priceObserver;
      }
    }

    // Re-apply price when mag carrier selection changes
    document.addEventListener('cloak:magCarrierChanged', function() {
      const colorItems = document.querySelectorAll('.cloak-color-item');
      let colorIndex = 0;
      colorItems.forEach(function(item, i) {
        if (item.classList.contains('active')) colorIndex = parseInt(item.getAttribute('data-color-index')) || 0;
      });
      updatePriceForColor(colorIndex, window.selectedColorProduct);
    });
    
    // Initialize selectedColorProduct from active item in DOM if present
    if (!window.selectedColorProduct && colorProducts.length > 0) {
      const activeItem = document.querySelector('.cloak-color-item.active');
      if (activeItem) {
        const productId = activeItem.getAttribute('data-product-id');
        const activeProduct = productId ? colorProducts.find(p => p.id.toString() === productId.toString()) : null;
        if (activeProduct) {
          window.selectedColorProduct = activeProduct;
          console.log('[Cloak Color] Initialized selectedColorProduct to active DOM color:', activeProduct.handle);
        }
      }
    }
    
    // Default to black on page load if no color is already selected
    // This ensures a color is always selected before user can add to cart
    if (!window.selectedColorProduct && colorProducts.length > 0) {
      // Find the black product (cloak-black)
      const blackProduct = colorProducts.find(p => {
        const handle = (p.handle || '').toLowerCase();
        return handle === 'cloak-black';
      });
      
      if (blackProduct) {
        // Set the selected color product immediately (before DOM is ready)
        window.selectedColorProduct = blackProduct;
        
        // Find the black color item in the DOM and update UI
        const blackItem = Array.from(colorItems).find(item => {
          const productId = item.getAttribute('data-product-id');
          return productId && productId.toString() === blackProduct.id.toString();
        });
        
        if (blackItem) {
          const colorIndex = parseInt(blackItem.getAttribute('data-color-index')) || 0;
          // Set black as default in UI
          handleColorClick(colorIndex, blackProduct, false);
        } else {
          // If DOM item not found yet, still set the product and update UI later
          setTimeout(() => {
            const blackItem = Array.from(document.querySelectorAll('.cloak-color-item')).find(item => {
              const productId = item.getAttribute('data-product-id');
              return productId && productId.toString() === blackProduct.id.toString();
            });
            if (blackItem) {
              const colorIndex = parseInt(blackItem.getAttribute('data-color-index')) || 0;
              handleColorClick(colorIndex, blackProduct, false);
            }
          }, 100);
        }
      }
    } else if (!window.selectedColorProduct) {
      // If no products loaded yet, try again after a delay
      setTimeout(() => {
        if (!window.selectedColorProduct && window.cloakColorProducts && window.cloakColorProducts.length > 0) {
          const neededHandle = getBlackProductHandleForCartItem();
          const blackProduct = window.cloakColorProducts.find(p => {
            const handle = (p.handle || '').toLowerCase();
            return handle === neededHandle;
          });
          if (blackProduct) {
            window.selectedColorProduct = blackProduct;
          }
        }
      }, 500);
    }
  }
  
  // Update second image to black immediately on page load
  function updateSecondImageToBlackImmediately() {
    const blackImageUrl = 'https://cdn.shopify.com/s/files/1/0881/4854/1726/files/4696e3b8-1420-44c9-b0f4-39215a3c779f.jpg?v=1763056859';
    
    const selectors = [
      `#Slider-Gallery-${sectionId} .product__media-item img:not([src*="badge"])`,
      '.product__media-item img:not([src*="badge"])',
      '.product-media-item img:not([src*="badge"])',
      '.product-media-container img.global-media-settings:not([src*="badge"])',
      '.product__media-wrapper img:not([src*="badge"])',
      '.product__media img:not([src*="badge"])'
    ];
    
    let allImages = [];
    for (const selector of selectors) {
      try {
        const images = document.querySelectorAll(selector);
        for (const img of images) {
          if (img && 
              !img.closest('.cloak-colors-section') && 
              !img.closest('.ready-to-ship-badge') &&
              !img.closest('.quick-ship-badge') &&
              !img.closest('.new-badge') &&
              !img.closest('.sale-badge') &&
              !img.closest('.coming-soon-badge') &&
              img.tagName === 'IMG') {
            const imgSrc = img.src || img.getAttribute('src') || '';
            if (imgSrc && 
                !imgSrc.includes('badge') &&
                (imgSrc.includes('products') || imgSrc.includes('files'))) {
              if (!allImages.includes(img)) {
                allImages.push(img);
              }
            }
          }
        }
      } catch (e) {
        // Selector might fail, continue
      }
    }
    
    // Update the second image (index 1) to black
    if (allImages.length > 1 && allImages[1] && allImages[1].tagName === 'IMG') {
      const secondImage = allImages[1];
      
      // Update the image source directly
      secondImage.src = blackImageUrl;
      if (secondImage.hasAttribute('srcset')) {
        secondImage.srcset = blackImageUrl;
      }
      
      // Also update any picture source elements
      const picture = secondImage.closest('picture');
      if (picture) {
        const sources = picture.querySelectorAll('source');
        sources.forEach(source => {
          if (source.srcset) {
            source.srcset = blackImageUrl;
          }
        });
      }
    } else if (allImages.length > 0 && allImages[0] && allImages[0].tagName === 'IMG') {
      // Fallback to first image if second doesn't exist
      const firstImage = allImages[0];
      
      firstImage.src = blackImageUrl;
      if (firstImage.hasAttribute('srcset')) {
        firstImage.srcset = blackImageUrl;
      }
      
      // Also update any picture source elements
      const picture = firstImage.closest('picture');
      if (picture) {
        const sources = picture.querySelectorAll('source');
        sources.forEach(source => {
          if (source.srcset) {
            source.srcset = blackImageUrl;
          }
        });
      }
    }
  }
  
  // Watch for color upgrade option changes and update optic cut (option3) to "yes"
  function initOpticCutAutoUpdate() {
    // Check if we're on the cloak-color-injection template
    const isCloakColorInjection = document.querySelector('[data-template-suffix="cloak-color-injection"]') || 
                                   document.body.classList.contains('template-product-cloak-color-injection') ||
                                   (window.location.pathname.includes('/products/') && document.querySelector('#cloak-color-config'));
    
    if (!isCloakColorInjection) {
      return; // Only run for cloak-color-injection template
    }
    
    // List of color upgrade option names (case-insensitive matching)
    const colorUpgradeOptions = [
      'recon haze topo color upgrade',
      'arctic white color upgrade',
      'army green color upgrade',
      'black carbon fiber color upgrade',
      'dark grey color upgrade',
      'neon pink color upgrade',
      'police blue color upgrade',
      'purple color upgrade',
      'safety orange color upgrade',
      'safety yellow color upgrade'
    ];
    
    // Function to set option3 (optic cut) to "yes" or "no"
    function setOpticCutOption3(value) {
      try {
        // Find option3 container by looking for "Optic Cut" or third option
        const productFormInputs = document.querySelectorAll('.product-form__input');
        let option3Container = null;
        
        // Try to find by legend/label text containing "optic"
        for (const container of productFormInputs) {
          const legend = container.querySelector('legend')?.textContent?.toLowerCase() || '';
          const label = container.querySelector('.form__label')?.textContent?.toLowerCase() || '';
          if (legend.includes('optic') || label.includes('optic')) {
            option3Container = container;
            break;
          }
        }
        
        // If not found by text, use third option
        if (!option3Container && productFormInputs.length >= 3) {
          option3Container = productFormInputs[2];
        }
        
        if (!option3Container) return;
        
        // Check if it's a select or radio
        const select = option3Container.querySelector('select[name*="option"]');
        if (select) {
          const targetOption = Array.from(select.options).find(opt => {
            const optValue = opt.value.toLowerCase().trim();
            const optText = opt.text.toLowerCase().trim();
            return optValue === value || optText === value || optText.includes(value);
          });
          if (targetOption && select.value !== targetOption.value) {
            select.value = targetOption.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            select.dispatchEvent(new Event('input', { bubbles: true }));
          }
          return;
        }
        
        // Find all radio buttons in option3 container
        const allRadios = option3Container.querySelectorAll('input[type="radio"]');
        if (allRadios.length === 0) return;
        
        // Find the target radio button
        let targetRadio = null;
        for (const radio of allRadios) {
          const radioValue = radio.value.toLowerCase().trim();
          // Check value
          if (radioValue === value || radioValue.includes(value)) {
            targetRadio = radio;
            break;
          }
          // Check label text - use CSS.escape to handle special characters in IDs
          if (radio.id) {
            const label = document.getElementById(radio.id.replace(/^option/, 'label-')) || 
                         document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
            if (label) {
              const labelText = label.textContent?.toLowerCase().trim() || '';
              if (labelText === value || labelText.includes(value)) {
                targetRadio = radio;
                break;
              }
            }
          }
        }
        
        if (targetRadio && !targetRadio.checked) {
          // Directly set checked state and trigger events to avoid recording script issues
          try {
            // Uncheck other radios in the same container (same group) first
            // Use the container we already found instead of accessing the name property
            // Use setAttribute/removeAttribute instead of property assignment to avoid recording script interception
            allRadios.forEach(r => {
              if (r !== targetRadio) {
                try {
                  r.removeAttribute('checked');
                  // Also set the property for compatibility
                  if (r.checked) r.checked = false;
                  r.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (e) {
                  // Ignore errors from recording scripts
                }
              }
            });
            
            // Set the target radio as checked using setAttribute to avoid recording script interception
            try {
              targetRadio.setAttribute('checked', 'checked');
              // Also set the property for compatibility
              if (!targetRadio.checked) targetRadio.checked = true;
              targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
              targetRadio.dispatchEvent(new Event('input', { bubbles: true }));
            } catch (e) {
              // Ignore errors from recording scripts
            }
            
            // Also try to click the label if it exists (wrapped in try-catch to handle recording script errors)
            const label = targetRadio.id ? 
                         (document.getElementById(targetRadio.id.replace(/^option/, 'label-')) || 
                          (() => {
                            try {
                              return document.querySelector(`label[for="${CSS.escape(targetRadio.id)}"]`);
                            } catch (e) {
                              return null;
                            }
                          })()) : 
                         null;
            if (label) {
              try {
                label.click();
              } catch (e) {
                // Ignore errors from recording scripts
              }
            }
          } catch (e) {
            // Fallback: try direct click if setting checked fails
            try {
              targetRadio.click();
            } catch (e2) {
              // Ignore all errors - recording script issues shouldn't break functionality
            }
          }
        }
      } catch (error) {
        // Silently handle errors from external recording scripts or other issues
        // This prevents errors from breaking the optic cut auto-update functionality
        console.error('[Cloak Color] Error in setOpticCutOption3:', error);
      }
    }
    
    // Function to check if selected option is a color upgrade
    function isColorUpgrade(selectedText) {
      if (!selectedText) return false;
      const lowerText = selectedText.toLowerCase().trim();
      return colorUpgradeOptions.some(upgrade => lowerText.includes(upgrade) || upgrade.includes(lowerText));
    }
    
    // Function to check if selected option is black
    function isBlackOption(selectedText) {
      if (!selectedText) return false;
      const lowerText = selectedText.toLowerCase().trim();
      return lowerText.includes('black') && !lowerText.includes('carbon fiber');
    }
    
    // Watch for changes on option1 (first dropdown)
    function setupOption1Watcher() {
      // Find the first option dropdown/select
      const productFormInputs = document.querySelectorAll('.product-form__input');
      if (productFormInputs.length === 0) return;
      
      const firstOptionContainer = productFormInputs[0];
      const firstOptionInput = firstOptionContainer.querySelector('select[name*="option"], input[name*="option"]');
      
      if (firstOptionInput) {
        // Remove existing listener if any (to avoid duplicates)
        const newHandler = function() {
          let selectedText = '';
          
          if (this.tagName === 'SELECT') {
            const selectedOption = this.options[this.selectedIndex];
            selectedText = selectedOption ? selectedOption.text : '';
          } else if (this.type === 'radio' && this.checked) {
            const label = this.nextElementSibling?.textContent || '';
            const labelFor = document.querySelector(`label[for="${this.id}"]`)?.textContent || '';
            const parentLabel = this.closest('label')?.textContent || '';
            selectedText = label || labelFor || parentLabel;
          }
          
          // Check if it's a color upgrade or black
          if (isColorUpgrade(selectedText)) {
            // Set option3 to "yes" with multiple attempts
            setTimeout(() => setOpticCutOption3('yes'), 200);
            setTimeout(() => setOpticCutOption3('yes'), 500);
            setTimeout(() => setOpticCutOption3('yes'), 800);
          } else if (isBlackOption(selectedText)) {
            // Set option3 to "no" with multiple attempts
            setTimeout(() => setOpticCutOption3('no'), 200);
            setTimeout(() => setOpticCutOption3('no'), 500);
            setTimeout(() => setOpticCutOption3('no'), 800);
          }
        };
        
        // Add change listener
        firstOptionInput.addEventListener('change', newHandler);
        
        // Also watch for value changes using MutationObserver (for programmatic updates)
        let previousValue = firstOptionInput.value || (firstOptionInput.checked ? firstOptionInput.value : '');
        const valueObserver = new MutationObserver(() => {
          const currentValue = firstOptionInput.value || (firstOptionInput.checked ? firstOptionInput.value : '');
          if (currentValue !== previousValue) {
            previousValue = currentValue;
            newHandler.call(firstOptionInput);
          }
        });
        
        // Observe the select element and its parent for changes
        valueObserver.observe(firstOptionInput, { attributes: true, attributeFilter: ['value', 'selected'] });
        if (firstOptionInput.parentElement) {
          valueObserver.observe(firstOptionInput.parentElement, { childList: true, subtree: true });
        }
      }
    }
    
    // Also watch for variant ID changes (when color selector updates variant directly)
    function watchVariantChanges() {
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        let previousVariantId = variantInput.value;
        
        const variantObserver = new MutationObserver(() => {
          const currentVariantId = variantInput.value;
          if (currentVariantId !== previousVariantId && currentVariantId) {
            previousVariantId = currentVariantId;
            // Variant changed, check option1 and update option3 if needed
            setTimeout(() => {
              const productFormInputs = document.querySelectorAll('.product-form__input');
              if (productFormInputs.length > 0) {
                const firstOptionContainer = productFormInputs[0];
                const firstOptionInput = firstOptionContainer.querySelector('select[name*="option"], input[name*="option"]');
                if (firstOptionInput) {
                  let selectedText = '';
                  if (firstOptionInput.tagName === 'SELECT') {
                    const selectedOption = firstOptionInput.options[firstOptionInput.selectedIndex];
                    selectedText = selectedOption ? selectedOption.text : '';
                  } else if (firstOptionInput.type === 'radio' && firstOptionInput.checked) {
                    const label = firstOptionInput.nextElementSibling?.textContent || '';
                    const labelFor = document.querySelector(`label[for="${firstOptionInput.id}"]`)?.textContent || '';
                    const parentLabel = firstOptionInput.closest('label')?.textContent || '';
                    selectedText = label || labelFor || parentLabel;
                  }
                  
                  if (isColorUpgrade(selectedText)) {
                    setOpticCutOption3('yes');
                    setTimeout(() => setOpticCutOption3('yes'), 300);
                    setTimeout(() => setOpticCutOption3('yes'), 600);
                  } else if (isBlackOption(selectedText)) {
                    setOpticCutOption3('no');
                    setTimeout(() => setOpticCutOption3('no'), 300);
                    setTimeout(() => setOpticCutOption3('no'), 600);
                  }
                }
              }
            }, 100);
          }
        });
        
        variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
    }
    
    // Initialize watcher with delays to ensure DOM is ready
    setTimeout(setupOption1Watcher, 100);
    setTimeout(setupOption1Watcher, 500);
    setTimeout(setupOption1Watcher, 1000);
    setTimeout(watchVariantChanges, 200);
    setTimeout(watchVariantChanges, 500);
    
    // Also watch for dynamically added elements
    const observer = new MutationObserver(() => {
      setupOption1Watcher();
      watchVariantChanges();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Initialize optic cut auto-update
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOpticCutAutoUpdate);
  } else {
    initOpticCutAutoUpdate();
  }
  
  // Run on DOMContentLoaded and with multiple delays to catch the image
  function initializeWithBlackImage() {
    try {
    updateSecondImageToBlackImmediately();
    
    // Try multiple times to catch images that load later
    setTimeout(updateSecondImageToBlackImmediately, 100);
    setTimeout(updateSecondImageToBlackImmediately, 300);
    setTimeout(updateSecondImageToBlackImmediately, 500);
    
    loadColorProducts();
    } catch (error) {
      console.error('[Cloak Color] initializeWithBlackImage: Error during initialization:', error);
    }
  }
  
  // Initialize if config is found, otherwise return false to trigger retry
  if (initializeColorShellSelector()) {
    // Config found, proceed with initialization
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeWithBlackImage);
    } else {
      initializeWithBlackImage();
    }
  } else {
    // Config not found yet, set up retry logic
    let retryCount = 0;
    const maxRetries = 10;
    const retryInterval = 500; // 500ms between retries
    
    function retryInitialization() {
      retryCount++;
      
      if (initializeColorShellSelector()) {
        // Config found, proceed with initialization
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initializeWithBlackImage);
        } else {
          initializeWithBlackImage();
        }
      } else if (retryCount < maxRetries) {
        // Try again after delay
        setTimeout(retryInitialization, retryInterval);
      }
    }
    
    // Start retrying after a short delay
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(retryInitialization, 100);
      });
    } else {
      setTimeout(retryInitialization, 100);
    }
  }

})();

// Collection Grid Color Swatches
// Add color swatches to collection grid images for products using cloak-color-injection template
(function() {
  'use strict';
  
  // Script initialization
  if (typeof document === 'undefined') {
    console.error('[Collection Swatches] Document not available!');
    return;
  }
  
  // Color product IDs/handles for collection grid swatches
  // All colors matching the product page color selector (including all color upgrade products)
  const colorProductIds = [
    'cloak-black',
    'cloak-arctic-white',
    'cloak-safety-yellow',
    'cloak-neon-pink',
    'cloak-safety-orange',
    'cloak-purple',
    'cloak-police-blue',
    'cloak-army-green',
    'cloak-black-carbon-fiber',
    'cloak-dark-grey',
    'cloak-recon-haze-topo'
  ];
  
  // Color mapping for swatches - square swatches for collection grid
  // Colors match the exact product page color selector
  const colorMap = {
    'cloak-black': '#000000',
    'cloak-arctic-white': '#FFFFFF',
    'cloak-army-green': '#605834',
    'cloak-black-carbon-fiber': '#1A1A1A',
    'cloak-dark-grey': '#525152',
    'cloak-neon-pink': '#fe8db5',
    'cloak-police-blue': '#293147',
    'cloak-purple': '#472e62',
    'cloak-safety-orange': '#fd6701',
    'cloak-safety-yellow': '#f7fe43',
    'cloak-recon-haze-topo': '#84735b'
  };
  
  // Check if product uses cloak-color-injection or cloak-color template
  function checkProductTemplate(card) {
    if (!card) return false;
    
    const templateSuffix = card.getAttribute('data-template-suffix');
    return templateSuffix === 'cloak-color-injection' || templateSuffix === 'cloak-color';
  }
  
  // Cache for color products to avoid repeated fetches
  let colorProductsCache = null;
  
  // Load color products data - optimized with parallel fetching and caching
  async function loadColorProducts() {
    // Return cached data if available
    if (colorProductsCache) {
      return colorProductsCache;
    }
    
    // Fetch all products in parallel for faster loading
    const fetchPromises = colorProductIds.map(async (productId) => {
      try {
        const response = await fetch(`/products/${productId}.js`);
        if (response.ok) {
          const product = await response.json();
          if (product && product.id) {
            return product;
          }
        }
      } catch (error) {
        console.error('[Collection Swatches] Error loading product', productId, ':', error);
      }
      return null;
    });
    
    const products = (await Promise.all(fetchPromises)).filter(p => p !== null);
    
    // Cache the results
    colorProductsCache = products;
    
    return products;
  }
  
  // Render color swatches for a product card
  function renderColorSwatches(swatchContainer, colorProducts, currentProductHandle) {
    if (!swatchContainer) {
      console.error('[Collection Swatches] No swatch container provided');
      return;
    }
    
    if (!colorProducts || colorProducts.length === 0) {
      console.error('[Collection Swatches] No color products provided');
      return;
    }
    
    const swatchesHtml = colorProducts.map(product => {
      const handle = product.handle || '';
      const color = colorMap[handle] || '#CCCCCC';
      const isOutOfStock = !product.available || (product.variants && !product.variants.some(v => v.available));
      const outOfStockClass = isOutOfStock ? ' out-of-stock' : '';
      const isWhite = color.toUpperCase() === '#FFFFFF' || color.toLowerCase() === 'white';
      const whiteClass = isWhite ? ' swatch-white' : '';
      const productUrl = `/products/${handle}`;
      
      return `<a href="${productUrl}" class="collection-color-swatch${outOfStockClass}${whiteClass}" 
                 style="background-color: ${color}; width: 24px; height: 24px; display: block;" 
                 title="${product.title || handle}"
                 data-product-handle="${handle}"></a>`;
    }).join('');
    
    if (swatchesHtml.length === 0) {
      console.error('[Collection Swatches] No HTML generated!');
      return;
    }
    
    // Clear any existing content and inline styles first
    swatchContainer.innerHTML = '';
    swatchContainer.removeAttribute('style');
    
    // Set all styles with !important using setAttribute
    const inlineStyle = 'display: flex !important; visibility: visible !important; opacity: 1 !important; z-index: 9999 !important; position: absolute !important; bottom: 12px !important; right: 12px !important; gap: 6px !important; flex-wrap: wrap !important;';
    swatchContainer.setAttribute('style', inlineStyle);
    
    // Now add the HTML
    swatchContainer.innerHTML = swatchesHtml;
  }
  
  // Process collection grid cards
  async function processCollectionGrid() {
    const productCards = document.querySelectorAll('.card-wrapper[data-product-handle]');
    if (productCards.length === 0) {
      return;
    }
    
    // Load color products once
    const colorProducts = await loadColorProducts();
    if (colorProducts.length === 0) {
      return;
    }
    
    // Process each card
    for (const card of productCards) {
      const productHandle = card.getAttribute('data-product-handle');
      if (!productHandle) continue;
      
      // Check if this product uses cloak-color-injection or cloak-color template
      if (!checkProductTemplate(card)) {
        continue; // Skip products that don't use the template
      }
      
      const cardMedia = card.querySelector('.card__media');
      const cardInner = card.querySelector('.card__inner');
      
      if (cardMedia) {
        cardMedia.style.boxSizing = 'border-box';
        cardMedia.style.overflow = 'visible';
      }
      
      // Make card__inner the positioning context
      if (cardInner) {
        cardInner.style.position = 'relative';
        cardInner.style.overflow = 'visible';
      }
      
      // Remove any existing swatch container
      const existingContainer = card.querySelector('.collection-color-swatches');
      if (existingContainer) {
        existingContainer.remove();
      }
      
      // Create a NEW swatch container and add it directly to card__inner
      const swatchContainer = document.createElement('div');
      swatchContainer.className = 'collection-color-swatches';
      swatchContainer.setAttribute('data-product-handle', productHandle);
      
      // Add it to card__inner (or card__media as fallback)
      if (cardInner) {
        cardInner.appendChild(swatchContainer);
      } else if (cardMedia) {
        cardMedia.appendChild(swatchContainer);
      } else {
        console.error('[Collection Swatches] No card__inner or card__media found');
        continue;
      }
      
      // Render swatches
      renderColorSwatches(swatchContainer, colorProducts, productHandle);
    }
  }
  
  // Initialize on page load - optimized for faster rendering
  function initCollectionSwatches() {
    // Check if we have product cards (works on collection, search, and other pages)
    const hasProductCards = document.querySelectorAll('.card-wrapper[data-product-handle]').length > 0;
    
    if (!hasProductCards) {
      return;
    }
    
    // Use requestAnimationFrame for immediate processing when DOM is ready
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      requestAnimationFrame(() => {
        processCollectionGrid();
      });
    } else {
      processCollectionGrid();
    }
    
    // Reduced delays - only one additional check for dynamically loaded content
    setTimeout(() => processCollectionGrid(), 200);
  }
  
  // Run initialization - try multiple ways to ensure it runs
  function runInit() {
    initCollectionSwatches();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
  
  // Also try on window load as a fallback
  window.addEventListener('load', () => {
    setTimeout(runInit, 100);
  });
  
  // And try immediately with a small delay
  setTimeout(() => runInit(), 100);
  
  // Also run when collection grid updates (for AJAX-loaded content) - optimized debounce
  let observerTimeout = null;
  const observer = new MutationObserver(() => {
    // Reduced debounce time for faster updates
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => {
      requestAnimationFrame(() => {
        processCollectionGrid();
      });
    }, 150);
  });
  
  // Observe collection grid container or body if no specific container
  const gridContainer = document.querySelector('#ProductGridContainer, #product-grid, ul.grid, .product-grid');
  if (gridContainer) {
    observer.observe(gridContainer, {
      childList: true,
      subtree: true
    });
  } else {
    // Fallback: observe body for any product cards
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();



